import $ from 'jquery';
import '../js/plugins/1.jquery.datepicker.picker';
import '../js/plugins/2.jquery.datepicker.picker.date';
import '../js/plugins/3.jquery.datepicker.picker.time';
import '../js/plugins/4.jquery.datepicker.legacy';
import '../js/plugins/5.jquery.datepicker.da_DK';

import '../js/plugins/IP.ScrollEvent';
import '../js/plugins/IP.Validation';

import alertify from '../js/plugins/jquery.alertify';
import '../js/plugins/jquery.cookieconsent';
import '../js/plugins/jquery.fancybox';
import '../js/plugins/jquery.hash';
import Headroom from '../js/plugins/jquery.headroom';
import '../js/plugins/jquery.metadata';
import '../js/plugins/jquery.placeholder';
import '../js/plugins/jquery.rangeslider';
// import '../js/plugins/z.2.googleCharts';
import '../js/plugins/jquery.responsive-tables';

import '../js/plugins/jquery.tools';
import Highcharts from 'highcharts';
import Data from 'highcharts/modules/data';
import Drilldown from 'highcharts/modules/drilldown';


import pensionForecastGraph from '../js/charts/pension-forecast-graph';

import svg4everybody from 'svg4everybody';
import '../js/plugins/z.7.cleaver';
import '../js/plugins/z.8.bootstrap-datepicker';

// Add an alias to the App, if we need to call App from the outside:
global.App = window.App = window.App || {};
global.alertify = window.alertify = alertify;

Data(Highcharts);
Drilldown(Highcharts);


/* global App */
// change className of html from .noJS to .hasJS.
(function (el) { el.className = el.className.replace('no-js', 'has-js'); })(document.documentElement);

/* device detection x */
var userAgent = navigator.userAgent;
var device = {
    iPad: userAgent.match(/iPad/),
    iPhone: userAgent.match(/iPhone/),
    iPod: userAgent.match(/iPod/),
    iOS: userAgent.match(/(iPhone|iPod|iPad)/),
    blackberry: userAgent.match(/BlackBerry/),
    android: userAgent.match(/Android/),
    webOS: userAgent.match(/webOS/),
    desktop: userAgent.match(/Win|Mac|X11|Linux/)
};
window.isMobileDevice = false;

window.GoogleAnalyticsEvent = function (kategori, action, label, value) {
    if (typeof window.ga === 'function') {
        window.ga('send', 'event', kategori, action, label, value);
    }
};

window.GoogleAnalyticsEvent = function (kategori, action, label) {
    if (typeof window.ga === 'function') {
        window.ga('send', 'event', kategori, action, label);
    }
};

window.testchangenavn = function (id) {
    if (!validateRequiredField('#' + id)) {
        $('#' + id).next('div').children('p').text('Navn skal udfyldes');
    } else {
        if (!validateName(this)) {
            $('#' + id).next('div').children('p').text('Navn er ugyldigt');
        }
    }
};


// reCAPTCHAValidateExpiredCallback
window.reCAPTCHACallback = function () {
    RemoverecaptcaError();
};

window.reCAPTCHAExpiredCallback = function () {
    var VedhaeftetFilerChedked = $('input[name="VedhaeftFiler"]').is(':checked');
    var ErDerUploadetFiler = $('.fileupload-table tbody tr').length > 0;

    if (VedhaeftetFilerChedked && ErDerUploadetFiler) { ShowRecaptchaError(); }
};

// kun til indtastning af tal
window.isNumberKey = function (evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) { return false; }
    return true;
};

// kun til indtastning af tal - uden 0 til at starte med
window.isNumberKey = function (evt, t) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (!((t.value == undefined || t.value == '') && charCode == 48)) {
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    } else {
        return false;
    }
};


// kun til indtastning af tal, komma og punktum
window.isNumberKeyOrSeperator2 = function (evt) {
    var accepted = [46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (accepted.indexOf(charCode) > -1) { return true; } else { return false; }
};

(function ($) {
    App.common = {
        // App.common.init runs on all pages
        init: function () {

            svg4everybody();

            function isTouchScreen() {
                var bool = false;
                var DocumentTouch = DocumentTouch || {};
                if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
                    bool = true;
                }
                return bool;
            }

            if (isTouchScreen() && !device.iPad) {
                var lastScroll = 0;
                var timer;
                $('#pagewrap').scroll(function (e) {

                    if (timer) {
                        clearTimeout(timer);
                    }

                    var $this = $(this);
                    timer = setTimeout(function () {
                        var st = $this.scrollTop();

                        if (st > lastScroll && st > 60) {
                            $('body').addClass('animated slideUp');
                            $('body').removeClass('slideDown');
                        } else {
                            $('body').addClass('slideDown');
                            $('body').removeClass('slideUp');
                        }

                        lastScroll = st;

                    }, 100);


                });


                if (device.iOS) {
                    $(document).on('focus', 'input[type="text"], input[type="search"], input[type="number"], textarea', function () {
                        if ($('body').hasClass('headroom--not-top')) {
                            $('.header-mobile-bar, .header-bottom').addClass('invisible');
                        }
                    }).on('blur', 'input[type="text"], input[type="search"], input[type="number"], textarea', function () {
                        $('.header-mobile-bar, .header-bottom').removeClass('invisible');
                    });
                }
            } else if (!device.iPad) {
                $('html:not(.lt-ie9) body').headroom({
                    offset: 100,
                    tolerance: 0,
                    classes: {
                        initial: 'animated',
                        pinned: 'slideDown',
                        unpinned: 'slideUp'
                    }
                });
            } else if (device.iPad) {
                $('body').headroom({
                    offset: 100,
                    tolerance: 0,
                    classes: {
                        initial: '',
                        pinned: '',
                        unpinned: ''
                    }
                });
            }



            alertify.confirmation = function (msg, fn) {
                alertify.set({ labels: { ok: 'Luk' } });
                alertify.alert(msg, fn || $.noop, 'confirmation-dialog');
                alertify.set({ labels: { ok: 'Ok' } });
            };


            alertify.ok = function (msg) {
                alertify.alert(msg, $.noop, 'alertify-ok');
                alertify.set({ labels: { ok: 'Ok' } });
            };


            /* add class to body if mobile */
            if (device.iOS || device.android || device.webOS) {
                isMobileDevice = true;
                $('body').addClass('mobile-device');
            }

            App.Util.lightbox.init();


            App.Util.datepicker.init();

            App.Util.tabs.init();

            App.Util.rangeSlider();

            App.Util.offCanvas();

            App.Util.pensionsberegner.init();

            App.Util.tooltip.init();

            App.Util.placeholder.init();

            App.Upload.Init();


            $('.print').on('click', function () {
                window.print();
                return false;
            });

            var languageSelector = $('.language-selector');
            if (isMobileDevice) {
                languageSelector.on('click', function () {
                    $(this).toggleClass('open');
                });

                $(document).on('touchstart', function (e) {
                    if ($('.language-selector').hasClass('open') && !($(e.target.offsetParent).parent().hasClass('language-selector'))) {
                        languageSelector.removeClass('open');
                    }
                });
            } else {
                languageSelector.mouseenter(function () {
                    $(this).addClass('open');
                }).mouseleave(function () {
                    $(this).removeClass('open');
                });
            }

            /* Fix for iOS9 - when menu is shown the  viewport zooms */
            var metaViewport = $('meta[name=viewport]');
            var metaViewportConten = metaViewport.attr('content');
            function metaViewportFix(metaViewport) {
                if (metaViewport.attr('content').indexOf('maximum-scale') === -1) {
                    metaViewport.attr('content', metaViewport.attr('content') + ',maximum-scale=1');
                } else {
                    metaViewport.attr('content', metaViewportConten);
                }
            }
            $(window).on('load orientationchange', function () {
                metaViewportFix(metaViewport);
                setTimeout(function () {
                    metaViewportFix(metaViewport);
                }, 1);
            });

            /* Fix for iOS9 end */


            $('.header-mobile-bar .menu-toggle').on('click', function () {
                $('body')
                    .toggleClass('mobile-navigation')
                    .toggleClass('mobile-navigation-show');

                $('.mobile-navigation-show #pagewrap').off('click').on('click', function () {
                    $('body')
                        .removeClass('mobile-navigation')
                        .removeClass('mobile-navigation-show');

                    metaViewportFix(metaViewport);
                });

                metaViewportFix(metaViewport);
                return false;
            });

            $('#pagewrap').off('touchmove').on('touchmove', function () {
                if ($('body').hasClass('mobile-navigation-show')) {
                    return false;
                }
            });



            // SEO TEST



            $('#IndLoebende').change(function () {
                if ($('#IndLoebende').is(':checked')) {
                    $('#tbEngang').attr('disabled', true);
                    $('#tbLoebende').attr('disabled', false);
                } else {
                    $('#tbEngang').attr('disabled', false);
                    $('#tbLoebende').attr('disabled', true);
                }
            });
            $('#IndEngang').change(function () {
                if ($('#IndEngang').is(':checked')) {
                    $('#tbEngang').attr('disabled', false);
                    $('#tbLoebende').attr('disabled', true);
                } else {
                    $('#tbEngang').attr('disabled', false);
                    $('#tbLoebende').attr('disabled', true);
                }
            });

            $('#SEOCBINDBETALING,#SEOCBINDBETALING2').change(function () {
                if (this.checked) {
                    $('#SEOCBINDBETALING').prop('checked', false);
                    $('#SEOCBINDBETALING2').prop('checked', false);
                    $('.rate').toggle();
                    $('.engang').toggle();
                }
            });
            $('#IkkeImplementeret').click(function () {
                alert('Mangler design fra Mithun');
            });

            $('#IkkeImplementeret2').click(function () {
                alert('Dankortflow ikke implementeret');
            });



            $('#btnShowPrognose').on('click', function () {
                $('#btnShowPrognose').addClass('is-loading', $('#prognosetabel').toggle(2000));
                $('#btnShowPrognose').removeClass('is-loading');
            });

            $('input[name="Vaelg-loebende-engang"]').on('change', function () {

                $('#Loebende').slideUp(500);
                $('#Engangs').slideUp(500);

                switch ($('input[name="Vaelg-loebende-engang"]:checked').val()) {

                    case 'Loebende':
                        // $('#naeste').attr('href', 'tpl-SEO-Godkend-rate.html');
                        $('#Loebende').slideDown(500);
                        break;

                    case 'Engangs':
                        $('#Engangs').slideDown(500);
                        // $('#naeste').attr('href', 'tpl-SEO-Godkend-engang.html');
                        break;
                }

            });




            $('.header-mobile-navigation .expandable > a').on('click', function (e) {
                var items = $(this).parents('.navigation-main').find('.expandable');
                var item = $(this).parent();

                if (item.hasClass('open')) {
                    item.removeClass('open');
                    return false;
                }
                items.removeClass('open');
                item.addClass('open');

                return false;
            });


            App.Util.search.init();

            App.Util.accordion.init();

            App.Util.showMore.init();

            App.Util.cookieConsent.init();

            // App.Util.stickyElm.init();

            App.Util.tae.init();
            App.Util.ks.init();
            App.Util.dod.init();
            App.Util.fleks.init();
            App.Util.feedback.init();
            App.Util.alderspension();
            // App.Util.begunstigelser.init();
            // App.Util.fileUploadMockup.init();
            App.Util.fileUploader.init();

        },

        showOverloebWarning: function () {

            if ($('input[name=rbtnpensionsberegner1]').is(':checked')) {

                $('#uiDiv_Warning').children().each(function () {
                    $(this).addClass('hide');
                });

                $('#uiDiv_Warning').removeClass('hide');
                var udb = $('input[name=rbtnpensionsberegner1]:checked').attr('id');
                // ekstraaldersforsikring, ekstrapension, livslangekstrapension
                if (udb == 'ekstraaldersforsikring') {
                    $('#uiP_Note_Aldersforsikring').removeClass('hide');

                } else if (udb == 'ekstrapension') {
                    $('#uiP_Note_Ekstrapension').removeClass('hide');
                } else if (udb == 'livslangekstrapension') {
                    $('#uiP_Note_Livslang').removeClass('hide');
                }
            } else {
                App.common.resetWarning();
            }
        },

        resetWarning: function () {
            $('#uiDiv_Warning').addClass('hide');
        },


        tilpasSliderFoerSliderchange: function () {

            var api = $('#rsEkstra').data('plugin_rangeslider');
            // var inputType = $this.data("type");
            var typed = $('#ipEkstra').val();

            // stringwithNumbers.replace(/(\d+),(?=\d{3}(\D|$))/g, "$1"); org= replace(/\./g, '');

            if (typed.indexOf('.') >= 0) { typed = $('#ipEkstra').val().replace(/(\d+).(?=\d{3}(\D|$))/g, '$1'); } // Hvis input IKKE er et int felt, kan tusindetalssepratorer forekomme (1.000)


            typed = typed.replace(/\,/g, '.'); // erstatter , med . (bliver fjernet igen ved math.floor())

            var min = api.min;
            var max = api.max;

            stepChange = true;

            var parent = $('#ipEkstra').parent();
            // var isInt = typed % 1 === 0 ; //Ser om der er en "rest" ved division med 1..
            if ($.isNumeric(typed) == false) {
                typed = min;
                parent.addClass('error');
                parent.next('.msg.error').show();
            } else {
                typed = Math.floor(typed);
                parent.removeClass('error');
                parent.next('.msg.error').hide();
            }

            api.setPosition(api.getPositionFromValue(typed));

            if (typed > max) {
                $('#ipEkstra').val(max);
                api.setPosition(api.getPositionFromValue(max));
                App.common.showOverloebWarning();
            } else if (typed < min) {
                $('#ipEkstra').val(min);
                api.setPosition(api.getPositionFromValue(min));
            } else if (typed >= min && typed <= max) {
                $('#ipEkstra').val(typed);
                api.setPosition(api.getPositionFromValue(typed));
            }
            var x = api.$element[0];
            return x;
        },

        SliderChange: function (selector) {
            /* var element = selector.id; //rsCurrentAge, rsPensionYear
            var currentAge = $("#rsCurrentAge").val();
            var pensionYear = $("#rsPensionYear").val();

            if (currentAge > pensionYear) {
                //CurrentAge flyttes
                if (element == "rsCurrentAge") {
                    $("#ipPensionYear").val(currentAge);
                    var api1 = $("#rsPensionYear").data("plugin_rangeslider")
                    if (api1 != null) {
                        api1.setPosition(api1.getPositionFromValue(currentAge));
                    }
                }
                else if (element == "rsPensionYear") {
                    //PensionYear flyttes
                    $("#ipCurrentAge").val(pensionYear);
                    var api2 = $("#rsCurrentAge").data("plugin_rangeslider")
                    if (api2 != null) {
                        var x = api2.getPositionFromValue(pensionYear);
                        api2.setPosition(x);
                    }
                }
            }
            if (App.Util.pensionsberegner.isReadyToCalculate() == true) {
                App.Util.pensionsberegner.calculate();
            } */




            var element = selector.id; // rsCurrentAge, rsPensionYear
            var currentAge = $('#rsCurrentAge').val();
            var pensionYear = $('#rsPensionYear').val();

            currentAge++;
            if (currentAge > pensionYear) {
                // CurrentAge flyttes
                if (element == 'rsCurrentAge') {
                    $('#ipPensionYear').val(currentAge);
                    var api1 = $('#rsPensionYear').data('plugin_rangeslider');
                    if (api1 != null) {
                        api1.setPosition(api1.getPositionFromValue(currentAge));
                    }
                } else if (element == 'rsPensionYear') {
                    // PensionYear flyttes
                    $('#ipCurrentAge').val(pensionYear - 1);
                    var api2 = $('#rsCurrentAge').data('plugin_rangeslider');
                    if (api2 != null) {
                        var x = api2.getPositionFromValue(pensionYear - 1);
                        api2.setPosition(x);
                    }
                }
            }

            if (App.Util.pensionsberegner.isReadyToCalculate() == true) {
                App.Util.pensionsberegner.calculate();
            }
        }
    };

    App.Util = App.Util || {
        alderspension() {
            if (document.querySelector('.js-alderspension')) import('./func/alderspension/index').then(module => new module.default());
        },
        feedback: {
            init: function () {
                $('.feedback-module .feedback-module-caller').on('click', function () {
                    $('.feedback-module .feedback-module-respond').stop().slideUp();

                    if ($(this).hasClass('feedback-module-caller-approve')) {
                        $('.feedback-module-respond-approve').stop().slideToggle();
                    } else {
                        $('.feedback-module-respond-reject').stop().slideToggle();
                    }
                });

                var ajaxFeedbackFormSubmit = function () {
                    var $form = $(this);
                    var options = {
                        url: $form.attr('action'),
                        type: $form.attr('method'),
                        data: $form.serialize()
                    };

                    $.ajax(options).done(function () {
                        var target = $form.attr('data-feedback-target');
                        $(target).stop().slideToggle();
                        $form.find('input[type=text], textarea, input[type=email]').val('');
                    });
                    return false;

                };
                $("form[data-feedback-ajax='true']").submit(ajaxFeedbackFormSubmit);

            }
        },
        equalHeight: {
            calculate: function (scope) {
                if (typeof scope === 'string') {
                    scope = ' ' + scope;
                } else {
                    scope = '';
                }
                if (device.desktop != null || device.iPad != null) {
                    var container = '.row.equal-height .col' + scope;
                    var currentTallest = 0;
                    var currentRowStart = 0;
                    var rowDivs = new Array();
                    var $el;
                    var topPosition = 0;
                    $(container).each(function () {

                        $el = $(this);
                        $($el).height('auto');
                        topPosition = $el.position().top;

                        if (currentRowStart != topPosition) {
                            for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                                rowDivs[currentDiv].height(currentTallest);
                            }
                            rowDivs.length = 0; // empty the array
                            currentRowStart = topPosition;
                            currentTallest = $el.height();
                            rowDivs.push($el);
                        } else {
                            rowDivs.push($el);
                            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
                        }
                        for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                            rowDivs[currentDiv].height(currentTallest);
                        }
                    });
                }
            }
        },
        tooltip: {
            init: function (scope) {
                $('.tooltip', scope).on('click', function () {
                    $('.tooltip', scope).removeClass('show');
                    $('.tip', scope).hide();
                    $(this).addClass('show');
                    // $(this).parent().find('.tip, .tip-overlay').show(); //Tooltip findes kun i første td-kolonne, og virker derfor ikke i kolonne 2 og 3..

                    $('body').append($(this).closest('div, th, td').find('.tip').clone());
                    var tip = $('body > .tip');
                    tip.show();

                    tip.css('height', tip.height());
                    var offset = $(this).parent().offset();
                    // tip.css('top', offset.top);
                    // tip.css('margin-top',-Math.abs(tip.height() / 2));
                    tip.center();

                    tip.before('<div class="tip-overlay" />');
                    tip.append('<a class="close" href="#">Luk</a>');

                    var overlay = $('body > .tip-overlay');
                    overlay.show();

                    tip.find('.close').on('click', function () {
                        tip.remove();
                        $('.tooltip.show', scope).removeClass('show');
                        overlay.remove();
                        return false;
                    });

                    overlay.on('click', function () {
                        tip.find('.close').trigger('click');
                        return false;
                    });


                    return false;
                });
            }
        },
        search: {
            init: function () {
                var searchBox = $('.search-box');
                var searchToggle = $('.navigation-top .btn-search');

                searchToggle.on('click', function () {
                    $(this).toggleClass('current');
                    searchBox.slideToggle(function () {
                        searchBox.find('input[type=search]').focus();
                    });
                    return false;
                });
                searchBox.find('.btn-close').on('click', function () {
                    searchToggle.trigger('click');
                    return false;
                });

                var searchBoxNew = $('.search-box');
                var searchToggleNew = $('.navigation-main .btn-search');

                searchToggleNew.on('click', function () {
                    $('#header').addClass('is-searching');
                    searchBoxNew.find('input[type=search]').focus();
                    return false;
                });


                searchBoxNew.find('.btn-close').on('click', function () {
                    $('#header').removeClass('is-searching');
                    return false;
                });
            }
        },
        accordion: {
            init: function (scope) {
                scope = scope ? scope + ' ' : '';

                $(scope + '.list-read-more > li > a').on('click', function () {
                    var self = $(this);
                    var parent = self.parents('li');

                    hash.add({ 'accordion': $(this).attr('href').replace('#', '') });
                    // function () { hash.remove('accordion'); }
                    parent.toggleClass('open');

                    parent.siblings().removeClass('open');
                    parent.siblings().find('section').stop().slideUp();

                    parent.find('section').stop().slideToggle(function () {
                        if (isMobileDevice) {
                            $('html, body').animate({ scrollTop: (parent.offset().top - self.outerHeight()) + 'px' }, 500);
                        } else {
                            $('html, body').animate({ scrollTop: (parent.offset().top - self.outerHeight()) + 'px' }, 600);
                        }
                    });

                    return false;
                });

                var hashAccordionVal = hash.get('accordion');
                $(scope + '.list-read-more > li > a[href="#' + hashAccordionVal + '"]').trigger('click');

            }
        },
        showMore: {
            init: function (scope) {
                scope = scope ? scope + ' ' : '';
                $(scope + '.show-more:not(.show-more-list-results, .show-more-messages)').on('click', function () {
                    var elm = $(this);
                    var href = elm.attr('href');

                    if (elm.hasClass('shortcuts')) {
                        $(href).toggleClass('open');
                        elm.toggleClass('open');
                    } else {
                        elm.toggleClass('loadingsearch');

                        setTimeout(function () {
                            $(href).slideToggle();
                            elm.toggleClass('loadingsearch');
                            elm.toggleClass('open');
                        }, 1000);
                    }

                    return false;
                });

                function loadMore(data) {

                    var rows = $(data).find('tbody tr.hide');
                    rows.slice(0, 10).fadeIn().removeClass('hide');
                    return $(data).find('tbody tr.hide').length;
                }

                // $(scope + '.show-more-data').prev().each(function( index ) {
                //   if(loadMore($(this)) == 0) {
                //            //$(this).fadeOut();
                //            $(this).next().html('Ikke flere poster');
                //        $(this).next().addClass('no-more-records');
                //        }

                // });

                // $(scope + '.show-more-data').prev().each(function( index ) {
                if ($(this).prev().find('tbody tr.hide').length == 0) {
                    // $(this).fadeOut();
                    $(this).html('Ikke flere poster');
                    $(this).addClass('no-more-records');
                }
                // });


                $(scope + '.show-more-data').on('click', function () {
                    var elm = $(this);
                    var table = $(this).prev();
                    elm.toggleClass('loadingsearch');

                    var more = loadMore(table);

                    if (more == 0) {
                        // $(this).fadeOut();
                        $(this).html('Ikke flere poster');
                        $(this).addClass('no-more-records');
                    }

                    setTimeout(function () {
                        elm.toggleClass('loadingsearch');
                    }, 500);
                    return false;
                });


                var hashItems = parseInt(hash.get('list-result-items'), 10);
                var totalListItems = $('.list-results > li').length;
                if (hashItems) {
                    $('.list-results > li').slice(0, hashItems).removeClass('hide');
                    if (totalListItems === hashItems) {
                        $('.show-more.show-more-list-results').hide();
                    }
                }

                $(scope + '.show-more.show-more-list-results').on('click', function () {
                    var elm = $(this);
                    var pagination = elm.data('pagination');

                    elm.addClass('loadingsearch');

                    setTimeout(function () {
                        elm.removeClass('loadingsearch');
                        $('.list-results > li.hide').slice(0, pagination).removeClass('hide');

                        var visibleListItems = $('.list-results > li:not(.hide)').length;

                        hash.add({ 'list-result-items': visibleListItems });
                        if (totalListItems === visibleListItems) {
                            elm.hide();
                        }

                    }, 300);

                    return false;
                });


                var msgHashItems = parseInt(hash.get('list-message-items'), 10);
                var msgTotalItems = $('.message-list > li').length;
                var msgPagination = $(scope + '.show-more.show-more-messages').data('pagination');

                if (msgHashItems) {
                    $('.message-list > li').slice(0, msgHashItems).removeClass('hide');
                } else {
                    $('.message-list > li').slice(0, msgPagination).removeClass('hide');
                }

                if (msgTotalItems === msgHashItems) {
                    $('.show-more.show-more-messages').hide();
                }

                $(scope + '.show-more.show-more-messages').on('click', function () {
                    var elm = $(this);

                    elm.addClass('loadingsearch');

                    setTimeout(function () {
                        elm.removeClass('loadingsearch');

                        $('.message-list > li.hide').slice(0, msgPagination).removeClass('hide');

                        var visibleListItems = $('.message-list > li:not(.hide)').length;
                        hash.add({ 'list-message-items': visibleListItems });


                        if (msgTotalItems === visibleListItems) {
                            elm.hide();
                        }

                    }, 3000);

                    return false;
                });


            }
        },
        cookieConsent: {
            init: function () {
                var cookieElm = $('.cookie-consent');

                if (cookieElm.length) {
                    $('html').addClass('has-cookie');
                }

                cookieElm.cookieConsent({
                    cookieName: 'cookieConsent',
                    btn: {
                        accept: '.accept'
                    },
                    transition: {
                        show: {
                            type: 'fadeIn',
                            duration: 500
                        },
                        hide: {
                            type: 'fadeOut',
                            duration: 500
                        }
                    },
                    consentType: 'explicit', // implied
                    onAccepted: function (elm) {
                        $('html').removeClass('has-cookie');
                    },
                    onDeclined: function (elm) {
                        $('html').removeClass('has-cookie');
                    },
                    onCheck: function (status) {
                        if (status != null) { $('#cookieStatus').val(status); } // FOR TEST
                    }
                });
            }
        },
        offCanvas: function () {

            $('.offCanvas .tab').on('click', function () {
                $('.offCanvas').toggleClass('show');

                setTimeout(function () {
                    $('body').on('click', function (e) {
                        var offCanvas = $(e.target.offsetParent).hasClass('offCanvas');
                        if (!offCanvas) {
                            $(this).off('click');
                            $('.offCanvas').toggleClass('show');
                        }
                    });
                }, 500);
                return false;
            });

        },
        rangeSlider: function (scope) {
            scope = scope ? scope + ' ' : '';

            $(scope + '.rangeslider').each(function () {
                var $this = $(this);
                var $val = $this.parents('.info-box').find('.sliderOut');
                var min = parseInt($this.attr('min'));
                var max = parseInt($this.attr('max'));
                var stepChange = false;

                $val.on('change', function (e) {
                    // remove everying that is not at digit
                    var formattedValue = e.target.value.replace(/\D/g, '')
                    // update the rangeslider value
                    $this.val(formattedValue).change();
                })

                $this.on('change', function (e) {
                    var value = e.target.value;
                    if (stepChange) {
                        value = $val.val();
                        stepChange = false;
                    }
                    // Update the '.sliderOut' value
                    $val.val(App.Util.format.call(value.split('.').join(''), '.', '.'));


                });

                $this.rangeslider({

                    // Deactivate the feature detection
                    polyfill: false,

                    // Callback function
                    onInit: function () {

                        $val.on('change', function () {


                            // var api = $this.data("plugin_rangeslider");
                            /// / var inputType = $this.data("type");
                            // var typed = $(this).val();

                            // //stringwithNumbers.replace(/(\d+),(?=\d{3}(\D|$))/g, "$1"); org= replace(/\./g, '');

                            // if (typed.indexOf(".") >= 0)
                            //     typed = $(this).val().replace(/(\d+).(?=\d{3}(\D|$))/g, "$1"); //Hvis input IKKE er et int felt, kan tusindetalssepratorer forekomme (1.000)


                            // typed = typed.replace(/\,/g, '.'); //erstatter , med . (bliver fjernet igen ved math.floor())

                            // var min = api.min;
                            // var max = api.max;

                            // stepChange = true;

                            // var parent = $(this).parent();
                            /// / var isInt = typed % 1 === 0 ; //Ser om der er en "rest" ved division med 1..
                            // if ($.isNumeric(typed) == false) {
                            //     typed = min;
                            //     parent.addClass('error');
                            //     parent.next('.msg.error').show();
                            // }
                            // else {
                            //     typed = Math.floor(typed);
                            //     parent.removeClass('error');
                            //     parent.next('.msg.error').hide();
                            // }

                            // api.setPosition(api.getPositionFromValue(typed));

                            // if (typed > max) {
                            //     $(this).val(max);
                            //     api.setPosition(api.getPositionFromValue(max));
                            // }
                            // else if (typed < min) {
                            //     $(this).val(min);
                            //     api.setPosition(api.getPositionFromValue(min));
                            // }
                            // else if (typed >= min && typed <= max) {
                            //     $(this).val(typed);
                            //     api.setPosition(api.getPositionFromValue(typed));
                            // }
                            // var x = api.$element[0];

                            var x = App.common.tilpasSliderFoerSliderchange();

                            App.common.SliderChange(x);
                        });
                    },


                    // Callback function
                    onSlide: function (position, value) {
                    },

                    onSlideEnd: function (position, value) {
                    }


                });

            });

        },
        format: function (comma, period) {
            comma = comma || ',';
            period = period || '.';
            var split = this.toString().split('.');
            var numeric = split[0];
            var decimal = split.length > 1 ? period + split[1] : '';
            var reg = /(\d+)(\d{3})/;
            while (reg.test(numeric)) {
                numeric = numeric.replace(reg, '$1' + comma + '$2');
            }
            return numeric + decimal;
        },
        lightbox: {
            init: function (scope) {
                scope = scope ? scope + ' ' : '';

                $(scope + 'a.video').each(function () {
                    if (device.iPhone) {
                        $(this).append('<iframe data-cookieconsent="marketing" width="100%" height="100%" data-src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen></iframe>');
                    }
                }).on('click', function () {
                    if (device.iPhone) {
                        return false;
                    } else if (Cookiebot.consent.marketing) {
                        $.fancybox({
                            'padding': 0,
                            'width': 680,
                            'height': 495,
                            'href': $(this).attr('href'),
                            'type': 'iframe',
                            iframe: {
                                preload: false
                            }
                        });
                        return false;
                    }
                });


                $(scope + '.lightbox').each(function () {
                    var elm = $(this);
                    var opts = App.Util.lightbox.options(elm.data(), {
                        padding: 10
                    });

                    elm.fancybox(opts);

                });

                $(scope + '.lightbox-elastic').each(function () {
                    var elm = $(this);
                    var opts = App.Util.lightbox.options(elm.data(), {
                        padding: 10,
                        openEffect: 'elastic',
                        openSpeed: 150,
                        closeEffect: 'elastic',
                        closeSpeed: 150,
                        closeClick: true,
                        helpers: {
                            overlay: null,
                            title: {
                                type: 'over'
                            }
                        }
                    });

                    elm.fancybox(opts);
                });

                $(scope + '.lightbox-nooverlay').each(function () {
                    var elm = $(this);
                    var opts = App.Util.lightbox.options(elm.data(), {
                        padding: 10,
                        helpers: {
                            overlay: null,
                            title: {
                                type: 'over'
                            }
                        }
                    });

                    elm.fancybox(opts);
                });

                $(scope + '.lightbox-gallery').fancybox({
                    padding: 10,
                    groupAttr: 'data-gallery-group',
                    helpers: {
                        title: {
                            type: 'over'
                        }
                    },
                    beforeLoad: function () {
                        this.title = (this.index + 1) + ' / ' + this.group.length + (this.title ? ' - ' + this.title : '');
                    }
                });

                $(scope + '.lightbox-gallery-thumbs').each(function () {
                    var elm = $(this);
                    var opts = App.Util.lightbox.options(elm.data(), {
                        padding: 10,
                        helpers: {
                            thumbs: {
                                width: 50,
                                height: 50
                            }
                        }
                    });

                    elm.fancybox(opts);
                });


                $(scope + '.lightbox-iframe').each(function () {
                    var elm = $(this);
                    var opts = App.Util.lightbox.options(elm.data(), {
                        width: '75%',
                        height: '75%',
                        padding: 10,
                        type: 'iframe',
                        iframe: {
                            scrolling: 'auto',
                            preload: true
                        },
                        autoSize: false
                    });

                    elm.fancybox(opts);
                });

                $(scope + '.lightbox-flash').each(function () {
                    var elm = $(this);
                    var opts = App.Util.lightbox.options(elm.data(), {
                        padding: 10,
                        type: 'swf',
                        swf: {
                            wmode: 'transparent',
                            allowfullscreen: 'true',
                            allowscriptaccess: 'always'
                        },
                        autoSize: false
                    });

                    elm.fancybox(opts);
                });


                $(scope + '.lightbox-ajax').each(function () {
                    var elm = $(this);
                    var opts = App.Util.lightbox.options(elm.data(), {
                        width: 500,
                        height: 500,
                        padding: 10,
                        type: 'ajax',
                        autoSize: false
                    });

                    elm.fancybox(opts);
                });

                $(scope + '.lightbox-inline').each(function () {
                    var elm = $(this);
                    var opts = App.Util.lightbox.options(elm.data(), {
                        padding: 20,
                        type: 'inline',
                        title: false,
                        minHeight: 0,
                        beforeLoad: function () {
                            var url = this.href;
                            if (!url) {
                                url = $(this).data('href');
                            }
                            var hash = url.substring(url.indexOf('#'));

                            this.href = hash;
                        }
                    });

                    elm.fancybox(opts);
                });
            },
            options: function (options, defaults) {
                return $.extend({}, defaults, options);
            }
        },
        datepicker: {
            init: function () {
                App.Util.datepicker.normal();
            },
            normal: function (scope) {

                function addDays(date, days) {
                    var result = new Date(date);
                    result.setDate(date.getDate() + days);
                    return result;
                }

                scope = scope ? scope + ' ' : '';
                var selector = scope + '.datepicker';

                $(selector).each(function (index, picker) {
                    var datepickerDataOpt = JSON.parse(JSON.stringify($(picker).data()).replace(/datepicker\s+/g, '').toLowerCase().replace(/datepicker/g, ''));

                    var options = {
                        today: false,
                        selectYears: 100,
                        selectMonths: false,
                        onOpen: function () {
                            $(picker).blur();
                            $('body').addClass('datepicker-open');
                        },
                        onRender: function () {
                            $(picker).blur();
                        },
                        onClose: function () {
                            $(picker).blur();
                            $('body').removeClass('datepicker-open');
                        },
                        onSet: function () {
                            var dateRangeSelector = this.$node.parent().parent();
                            var dateTo = dateRangeSelector.find('.datepicker.date-to').pickadate('picker');
                            var dateFrom = dateRangeSelector.find('.datepicker.date-from').pickadate('picker');
                            var selectedDate = null;

                            if (this.$node.pickadate('picker').get('select') != null) { selectedDate = this.$node.pickadate('picker').get('select').obj; }

                            if (this.$node.hasClass('date-from')) {
                                if (selectedDate != null) {
                                    var date = addDays(selectedDate, 1);
                                    if ((dateTo.get('select') != null) && (dateFrom.get('select').obj.getTime() >= dateTo.get('select').obj.getTime())) { dateTo.set('select', date); }
                                    dateTo.set('min', date);
                                }
                            }
                        }
                    };

                    options = $.extend(options, datepickerDataOpt);

                    $(picker).pickadate(options);

                });
            }
        },
        placeholder: {
            init: function () {
                App.Util.placeholder.normal();
            },
            normal: function (scope) {
                $('input, textarea').placeholder();
            }
        },
        tabs: {
            init: function () {
                App.Util.tabs.normal();
                App.Util.tabs.payment();
            },
            normal: function (scope) {
                scope = scope ? scope + ' ' : '';

                var hashTabIndex = hash.get('tab');
                var initialIndex = hashTabIndex ? hashTabIndex : 0;

                $(scope + 'ul.tabs:not(.tabs-custom)').tabs('.pane', {
                    tabs: 'li',
                    initialIndex: +initialIndex,
                    onClick: function (elm, index) {
                        // Don't add hash for the first tab
                        changeState(index);

                    }
                });

                if ($(scope + 'ul.tabs:not(.tabs-custom)').length) {
                    $(scope + 'ul.tabs:not(.tabs-custom)').data('tabs').onClick(function (e) {
                        var index = $(e.target).parent().index();
                        $(scope + '.tab-panes .tabs-nav').removeClass('current');
                        $(scope + '.tab-panes .tabs-nav').eq(index).addClass('current');
                    });
                    $(scope + '.tab-panes .tabs-nav').on('click', function (e) {
                        var index = $(e.target).parent().index();
                        changeState(index);
                        $(this).toggleClass('current');
                        $(this).next().slideToggle();
                        $(this).parent().siblings().find('.tabs-nav').removeClass('current');
                        $(this).parent().siblings().find('.pane').slideUp(function () {
                            $('#pagewrap').animate({ 'scrollTop': ($('#pagewrap').scrollTop() + $('.tab-panes').offset().top) - 60 }, 500);
                        });
                        $(scope + "ul.tabs.tabs-nav a[href='" + $(this).attr('href') + "']").parent().toggleClass('current');

                        return false;
                    });
                    $(scope + '.tab-panes .tabs-nav').removeClass('current').eq(initialIndex).addClass('current');
                }

                function changeState(index) {
                    if (index) {
                        hash.add({ 'tab': index });
                    } else {
                        if (hash.get('tab')) {
                            hash.remove('tab');
                        }
                    }

                    if (typeof window.ga === 'function') {
                        var locationHash = window.location.hash;

                        if (locationHash === '#!') {
                            locationHash = '';
                        }

                        var location = window.location.protocol +
                            '//' + window.location.hostname +
                            window.location.pathname +
                            window.location.search +
                            locationHash;

                        if (typeof window.ga === 'function') {
                            window.ga('send', {
                                'hitType': 'pageview',
                                'page': location
                            });
                        }
                    }
                }

            },
            payment: function (scope) {
                scope = scope ? scope + ' ' : '';
                $(scope + '.tabs-payment li').on('click', function () {
                    $(scope + '.tabs-payment li').removeClass('current');
                    $(this).addClass('current');

                    var cIndex = $(this).index();

                    $(scope + '.table-payout table:first td').removeClass('current');
                    $(scope + '.table-payout table:first tr:visible').each(function () {
                        $(this).find('td.invisible').eq(cIndex).addClass('current');
                    });

                    $(scope + '.tip:visible').trigger('click');

                    return false;
                });

                /* $(scope + '.tooltip').on('click', function () {
                     $(scope + '.tooltip').removeClass('show');
                     $(scope + '.tip').hide();
                     $(this).addClass('show');
                     $(this).parent().find('.tip, .tip-overlay').show(); //Tooltip findes kun i første td-kolonne, og virker derfor ikke i kolonne 2 og 3..

                     return false;
                 });
                 $(scope + '.tip').each(function () {
                     var elm = $(this);
                     elm.before('<div class="tip-overlay" />');
                     elm.append('<a class="close" href="#">Luk</a>');

                     var overlay = elm.prev('.tip-overlay');

                     elm.find('.close').on('click', function () {
                         elm.hide();
                         $(scope + '.tooltip.show').removeClass('show');
                         overlay.hide();
                         return false;
                     });
                     overlay.on('click', function () {
                         elm.find('.close').trigger('click');
                         return false;
                     });
                 }); */
            }
        },
        loading: {
            show: function () {
                this.action('add');
            },
            hide: function () {
                this.action('remove');
            },
            action: function (cmd) {
                $('html')[cmd + 'Class']('ajaxLoading');
            }
        },
        dod: {
            init: function () {
                var slidevalue = 500;

                $('#cbSamboende').click(function () {

                    if ($('#cbSamboende').prop('checked') === true) {
                        $('#divSamboende').slideDown(slidevalue);
                    } else {
                        $('#divSamboende').slideUp(slidevalue);
                    }
                });


                $('input[name="dod_Barn"]').click(function () {

                    SetUploadTekster();
                });

                $('#cbUmyndigt').click(function () {

                    SetUploadTekster();
                    if ($('#cbUmyndigt').prop('checked') === true) {
                        $('#divUmyndigt').slideDown(slidevalue);
                    } else {
                        $('#divUmyndigt').slideUp(slidevalue);
                    }

                });

                function SetUploadTekster() {

                    slideupUploadTekster();

                    if ($('#cbUmyndigt').prop('checked') == true) {

                        $('#divUmyndigtBarn').slideDown(slidevalue);
                        $('#divUmyndigtStedbarn').slideDown(slidevalue);
                        $('#divUmyndigtBarnebarn').slideDown(slidevalue);
                        $('#divUmyndigtStedBarnebarn').slideDown(slidevalue);
                        $('#divUmyndigtSoeskende').slideDown(slidevalue);

                    } else {

                        $('#divMyndigtBarn').slideDown(slidevalue);
                        $('#divMyndigtStedbarn').slideDown(slidevalue);
                        $('#divMyndigtBarnebarn').slideDown(slidevalue);
                        $('#divMyndigtStedBarnebarn').slideDown(slidevalue);
                        $('#divMyndigtSoeskende').slideDown(slidevalue);

                    }
                }

                function slideupUploadTekster() {

                    $('#divUmyndigtBarn').slideUp(slidevalue);
                    $('#divUmyndigtStedbarn').slideUp(slidevalue);
                    $('#divUmyndigtBarnebarn').slideUp(slidevalue);
                    $('#divUmyndigtStedBarnebarn').slideUp(slidevalue);
                    $('#divUmyndigtSoeskende').slideUp(slidevalue);

                    $('#divMyndigtBarn').slideUp(slidevalue);
                    $('#divMyndigtStedbarn').slideUp(slidevalue);
                    $('#divMyndigtBarnebarn').slideUp(slidevalue);
                    $('#divMyndigtStedBarnebarn').slideUp(slidevalue);
                    $('#divMyndigtSoeskende').slideUp(slidevalue);
                }


                $('input[name="StartModel.Tilhoersforhold"]').on('change', function () {

                    $('#divAegtefaelle').slideUp(slidevalue);
                    $('#divSamlever').slideUp(slidevalue);
                    $('#divBarn').slideUp(slidevalue);
                    $('#divBarneBarn').slideUp(slidevalue);
                    $('#divForaeldre').slideUp(slidevalue);
                    $('#divSoeskende').slideUp(slidevalue);
                    $('#divAndet').slideUp(slidevalue);
                    $('#divStedbarn').slideUp(slidevalue);
                    $('#divStedBarneBarn').slideUp(slidevalue);

                    switch ($('input[name="StartModel.Tilhoersforhold"]:checked').val()) {

                        case 'Aegtefaelle':
                            $('#naeste').attr('href', 'tpl-dod-aegtefaelle.html');
                            $('#divAegtefaelle').slideDown(slidevalue);
                            break;

                        case 'Samlever':
                            $('#divSamlever').slideDown(slidevalue);
                            $('#naeste').attr('href', 'tpl-dod-samlever.html');
                            break;

                        case 'Barn':
                            $('#naeste').attr('href', 'tpl-dod-Barn.html');
                            $('#divBarn').slideDown(slidevalue);
                            break;

                        case 'StedBarn':
                            $('#naeste').attr('href', 'tpl-dod-stedbarn.html');
                            $('#divStedbarn').slideDown(slidevalue);
                            break;

                        case 'BarneBarn':
                            $('#naeste').attr('href', 'tpl-dod-Barnebarn.html');
                            $('#divBarneBarn').slideDown(slidevalue);
                            break;

                        case 'StedBarneBarn':
                            $('#naeste').attr('href', 'tpl-dod-stedbarnebarn.html');
                            $('#divStedBarneBarn').slideDown(slidevalue);
                            break;

                        case 'Foraeldre':
                            $('#naeste').attr('href', 'tpl-dod-foraeldre.html');
                            $('#divForaeldre').slideDown(slidevalue);
                            break;

                        case 'Soeskende':
                            $('#naeste').attr('href', 'tpl-dod-soeskende.html');
                            $('#divSoeskende').slideDown(slidevalue);
                            break;

                        case 'Andet':
                            $('#naeste').attr('href', 'tpl-dod-andet.html');
                            $('#divAndet').slideDown(slidevalue);
                            break;


                    }

                });

                $('input[name="dod_Begunstiget"]').on('change', function () {

                    if ($('input[name="dod_Begunstiget"]:checked').val() == 'Ja') {
                        $('#Begunstiget').slideDown(slidevalue);
                        $('#BegunstigetJa').slideDown(slidevalue);
                        $('#BegunstigetNej').slideUp(slidevalue);
                    } else {
                        $('#Begunstiget').slideUp(slidevalue);
                        $('#BegunstigetJa').slideUp(slidevalue);
                        $('#BegunstigetNej').slideDown(slidevalue);
                    }

                });

                $('input[name="dod_Bankopl"]').on('change', function () {

                    $('#divDanskkonto').slideUp(slidevalue);
                    $('#divIndenforEuropa').slideUp(slidevalue);
                    $('#divUdenforEuropa').slideUp(slidevalue);

                    switch ($('input[name="dod_Bankopl"]:checked').val()) {

                        case 'Dansk':
                            $('#divDanskkonto').slideDown(slidevalue);
                            break;

                        case 'UdenforEuropa':
                            $('#divUdenforEuropa').slideDown(slidevalue);
                            break;

                        case 'IndenforEuropa':
                            $('#divIndenforEuropa').slideDown(slidevalue);
                            break;
                    }

                });

                $('input[name="dod_Bankopl_Forvaltningskonto"]').on('change', function () {

                    $('#divDanskkontoForvaltningskonto').slideUp(slidevalue);
                    $('#divIndenforEuropaForvaltningskonto').slideUp(slidevalue);
                    $('#divUdenforEuropaForvaltningskonto').slideUp(slidevalue);

                    switch ($('input[name="dod_Bankopl_Forvaltningskonto"]:checked').val()) {

                        case 'Dansk':
                            $('#divDanskkontoForvaltningskonto').slideDown(slidevalue);
                            break;

                        case 'UdenforEuropa':
                            $('#divUdenforEuropaForvaltningskonto').slideDown(slidevalue);
                            break;

                        case 'IndenforEuropa':
                            $('#divIndenforEuropaForvaltningskonto').slideDown(slidevalue);
                            break;
                    }

                });

                if ($('#cbDanskForvaltningskonto').prop('checked') === true) {
                    $('#divDanskkontoForvaltningskonto').slideDown(slidevalue);
                } else {
                    $('#divDanskkontoForvaltningskonto').slideUp(slidevalue);
                }

                if ($('#cbDanskForvaltningskonto').prop('checked') === true) {
                    $('#divDanskkontoForvaltningskonto').slideDown(slidevalue);
                } else {
                    $('#divDanskkonto').slideUp(slidevalue);
                }
            }
        },
        pensionstjek:
        {
            init: function () {
                var slideValue = 500;

                // Åbn forklarende tekst hvis civilstand er valgt tidligere
                var checkedRadioBtn = $('input[name=CivilstandValg]:checked');
                if (checkedRadioBtn != undefined && checkedRadioBtn.length > 0) {
                    checkedRadioBtn.closest('td').next('td').find('.box-light-gray').slideDown(slideValue);
                }

                // Tester bruger intput til felterne på formue siden
                function testMaxVaerdierFormueSide() {
                    // Tester om friværdi overstiger maxgrænsen
                    if (testVaerdipapirer())
                    // Tester om værdien af værdipapirer overstiger maxgrænsen
                    {
                        if (testFrivaerdi())
                        // Tester om formuen overstiger maxgrænsen
                        { return testFormue(); }
                    }
                    return false;
                }

                function testFormue() {
                    // Tester om formuen overstiger maxgrænsen
                    var maxformue = parseInt($('#maxformue').val());
                    var userInputFormue = $('#uiTbFormue').val();
                    if (userInputFormue > maxformue) {
                        var errorMaxFormueText = $('#errorMaxFormueText').val();
                        errorMaxFormueText = errorMaxFormueText.replace(/\maxFormue/g, maxformue);
                        $('#pErrorFormue').text(errorMaxFormueText);
                        $('#divErrorFormue').slideDown(slideValue);
                        return false;
                    }
                    return true;
                }

                function testVaerdipapirer() {
                    // Tester om værdien af værdipapirer overstiger maxgrænsen
                    var maxvaerdipapirer = parseInt($('#maxvaerdipapirer').val());
                    var userInputVaerdipapirer = $('#uiTbVaerdipapirer').val();
                    if (userInputVaerdipapirer > maxvaerdipapirer) {
                        var errorMaxVaerdipapirerText = $('#errorMaxVaerdipapirerText').val();
                        errorMaxVaerdipapirerText = errorMaxVaerdipapirerText.replace(/\maxVaerdipapirer/g, maxvaerdipapirer);
                        $('#pErrorVaerdipapirer').text(errorMaxVaerdipapirerText);
                        $('#divErrorVaerdipapirer').slideDown(slideValue);
                        return false;
                    }
                    return true;
                }

                function testFrivaerdi() {
                    // Tester om friværdi overstiger maxgrænsen
                    var maxfrivaerdi = parseInt($('#maxfrivaerdi').val());
                    var userInputFrivaerdi = $('#uiTbFrivaerdi').val();
                    if (userInputFrivaerdi > maxfrivaerdi) {
                        var errorMaxFrivaerdiText = $('#errorMaxFrivaerdiText').val();
                        errorMaxFrivaerdiText = errorMaxFrivaerdiText.replace(/\maxFrivaerdi/g, maxfrivaerdi);
                        $('#pErrorFrivaerdi').text(errorMaxFrivaerdiText);
                        $('#divErrorFrivaerdi').slideDown(slideValue);
                        return false;
                    }
                    return true;
                }

                $('#btnVisResultat').click(function () {
                    return testMaxVaerdierFormueSide();
                });

                /// /Tester bruger intput til felterne engangsindbetaling og månedlig indbetaling til simulering
                // function testMaxVaerdierSimulering() {
                //    //Tester om månedlig indbetaling overstiger maxgrænsen, tester om engangsindbetaling overstiger maxgrænsen
                //    if (testMaanedligIndbetaling() && testEngangsIndbetaling()) {
                //        loadSimuleringGrafPartialView();
                //        return true;
                //    }
                //    else
                //        return false;
                // }

                // function testMaanedligIndbetaling() {
                //    //Tester om friværdi overstiger maxgrænsen
                //    var maxEkstraMaanedligIndbetaling = parseInt($("#MaxEkstraMaanedligIndbetaling").val());
                //    var userInputEkstraMaanedligIndbetaling = $("#uiTbEkstraMaanedligIndbetaling").val();
                //    if (userInputEkstraMaanedligIndbetaling > maxEkstraMaanedligIndbetaling) {
                //        var errorMaxEkstraMaanedligIndbetaling = $("#ErrorMaxEkstraMaanedligIndbetaling").val();
                //        errorMaxEkstraMaanedligIndbetaling = errorMaxEkstraMaanedligIndbetaling.replace(/\maxEkstraMaanedligIndbetaling/g, maxEkstraMaanedligIndbetaling);
                //        $("#pErrorEkstraMaanedligIndbetaling").text(errorMaxEkstraMaanedligIndbetaling);
                //        $("#divErrorEkstraMaanedligIndbetaling").slideDown(slideValue);
                //        return false;
                //    }
                //    return true;
                // }

                // function testEngangsIndbetaling() {
                //    //Tester om friværdi overstiger maxgrænsen
                //    var maxEkstraEngangsIndbetaling = parseInt($("#MaxEkstraEngangsIndbetaling").val());
                //    var userInputEkstraEngangsIndbetaling = $("#uiTbEkstraEngangsIndbetaling").val();
                //    if (userInputEkstraEngangsIndbetaling > maxEkstraEngangsIndbetaling) {
                //        var errorMaxEkstraEngangsIndbetaling = $("#ErrorMaxEkstraEngangsIndbetaling").val();
                //        errorMaxEkstraEngangsIndbetaling = errorMaxEkstraEngangsIndbetaling.replace(/\maxEkstraEngangsIndbetaling/g, maxEkstraEngangsIndbetaling);
                //        $("#pErrorEkstraEngangsIndbetaling").text(errorMaxEkstraEngangsIndbetaling);
                //        $("#divErrorEkstraEngangsIndbetaling").slideDown(slideValue);
                //        return false;
                //    }
                //    return true;
                // }

                // $("#btnOpdaterSimulering").click(function () {
                //    return testMaxVaerdierSimulering();
                // });

                // Henter værdien af minumum løn og maksimum løn
                // Grænserne for input til ægtefælle/samlvers indkomst
                var minloen = parseInt($('#minloen').val());
                var maxloen = parseInt($('#maxloen').val());
                // Grænserne for input til egen indkomst
                var minloenegen = parseInt($('#minloenegen').val());
                var maxloenegen = parseInt($('#maxloenegen').val());
                var selectedradio;
                // Trykker på kanppen Næste
                $('#btnNaeste').click(function () {
                    var errortext;
                    var userInputEgenIndtaegt = $('#uiTbEgenIndtaegt').val();
                    // Egen indtægt skal være udfyldt
                    if (userInputEgenIndtaegt != undefined && userInputEgenIndtaegt.length <= 0) {
                        errortext = $('#ErrorEgenIndtaegtManglendeText').val();
                        $('#pErrorEgenIndtaegt').text(errortext);
                        $('#divErrorEgenIndtaegt').slideDown(slideValue);
                        return false;
                    }// Egen indtægt skal være imellem minimum og maksimum
                    else if (userInputEgenIndtaegt < minloenegen) {
                        $('#uiTbEgenIndtaegt').val(minloenegen);
                        errortext = $('#ErrorMinLoenTextEgen').val();
                        errortext = errortext.replace(/\minloenegen/g, minloenegen);
                        $('#pNoteEgenIndtaegt').text(errortext);
                        $('#divNoteEgenIndtaegt').slideDown(slideValue);
                        return false;
                    } else if (userInputEgenIndtaegt > maxloenegen) {
                        errortext = $('#ErrorMaxLoenTextEgen').val();
                        errortext = errortext.replace(/\maxloenegen/g, maxloenegen);
                        $('#pErrorEgenIndtaegt').text(errortext);
                        $('#divErrorEgenIndtaegt').slideDown(slideValue);
                        return false;
                    }
                    // Civilstand radioknapper skal være valgt
                    if ($('input[name=CivilstandValg]:checked').length <= 0) {
                        $('#divErrorVaelgCivilstand').slideDown(slideValue);
                        return false;
                    }
                    // Indtægtsfeltet for ægtefælle eller samlver (hvis valgt) skal være udfyldt og imellem minimum og maksimum
                    var userInputIndtaegt;
                    switch (selectedradio.attr('id')) {
                        case 'uiRadioIndtaegterAegtefaelle':
                            userInputIndtaegt = $('#uiTbIndtaegterAegtefaelle').val();
                            // Hvis Ægtefælle er valgt men indtægtsfeltet ikke er udfyldt
                            if (userInputIndtaegt.length <= 0) {
                                errortext = $('#ErrorAegtefaelleIndtaegtManglendeText').val();
                                $('#pErrorAegtefaelleIndtaegt').text(errortext);
                                $('#divErrorAegtefaelleIndtaegt').slideDown(slideValue);
                                return false;
                            }
                            // Hvis Ægtefælle er valgt men indtægtsfeltet ikke er imellem minimum og maksimum løn
                            else if (userInputIndtaegt < minloen) {
                                errortext = $('#ErrorMinLoenText').val();
                                errortext = errortext.replace(/\minloen/g, minloen);
                                $('#pErrorAegtefaelleIndtaegt').text(errortext);
                                $('#divErrorAegtefaelleIndtaegt').slideDown(slideValue);
                                return false;
                            } else if (userInputIndtaegt > maxloen) {
                                errortext = $('#ErrorMaxLoenText').val();
                                errortext = errortext.replace(/\maxloen/g, maxloen);
                                $('#pErrorAegtefaelleIndtaegt').text(errortext);
                                $('#divErrorAegtefaelleIndtaegt').slideDown(slideValue);
                                return false;
                            }
                            break;
                        case 'uiRadioIndtaegterSamlever':
                            userInputIndtaegt = $('#uiTbIndtaegterSamlever').val();
                            // Hvis samlever er valgt men indtægtsfeltet ikke er udfyldt
                            if (userInputIndtaegt.length <= 0) {
                                errortext = $('#ErrorSamleverIndtaegtManglendeText').val();
                                $('#pErrorSamleverIndtaegt').text(errortext);
                                $('#divErrorSamleverIndtaegt').slideDown(slideValue);
                                return false;
                            } // Hvis Samlever er valgt men indtægtsfeltet ikke er imellem minimum og maksimum løn
                            else if (userInputIndtaegt < minloen) {
                                errortext = $('#ErrorMinLoenText').val();
                                errortext = errortext.replace(/\minloen/g, minloen);
                                $('#pErrorSamleverIndtaegt').text(errortext);
                                $('#divErrorSamleverIndtaegt').slideDown(slideValue);
                                return false;
                            } else if (userInputIndtaegt > maxloen) {
                                errortext = $('#ErrorMaxLoenText').val();
                                errortext = errortext.replace(/\maxloen/g, maxloen);
                                $('#pErrorSamleverIndtaegt').text(errortext);
                                $('#divErrorSamleverIndtaegt').slideDown(slideValue);
                                return false;
                            }
                            break;
                    }
                    return true;
                });

                // Åbner gråt felt op med forklarende tekst og inputfelt hvis radiokanpper Gift eller Samlever vælges
                $('input:radio[name="CivilstandValg"]').change(function () {
                    $('#divErrorVaelgCivilstand').slideUp(slideValue);
                    selectedradio = $(this);
                    var elementstoclose = $('.table-product-form > tbody  > tr > td:nth-child(2) > div');
                    elementstoclose.each(function () {
                        if ($(this).is(':visible')) {
                            $(this).slideUp(slideValue);
                        }
                    });

                    elementstoclose.promise().done(function () {
                        selectedradio.closest('td').next('td').find('.box-light-gray').slideDown(slideValue);
                    });
                });

                // Når inputfelter mister fokus
                $('#uiTbIndtaegterAegtefaelle, #uiTbEgenIndtaegt, #uiTbIndtaegterSamlever,  #uiTbFormue,  #uiTbFrivaerdi,  #uiTbVaerdipapirer, #uiTbEkstraMaanedligIndbetaling, #uiTbEkstraEngangsIndbetaling').on('blur', function () {
                    var loeninput = parseInt($(this).val());
                    // Hvis lønnen ikk er imellem minimum og maksimum
                    var errortext;
                    var id = this.id;
                    switch (id) {
                        // Hvis egen indtægt ikke er imellem minimum og maksimum
                        case 'uiTbEgenIndtaegt':
                            // Egen indtægt skal være udfyldt
                            if (isNaN(loeninput) || loeninput == undefined || loeninput === '' || loeninput.length <= 0) {
                                errortext = $('#ErrorEgenIndtaegtManglendeText').val();
                                $('#pErrorEgenIndtaegt').text(errortext);
                                $('#divErrorEgenIndtaegt').slideDown(slideValue);
                                return false;
                            }// Hvis samlevers indtægt ikke er imellem minimum og maksimum
                            else if (loeninput < minloenegen) {
                                $('#uiTbEgenIndtaegt').val(minloenegen);
                                errortext = $('#ErrorMinLoenTextEgen').val();
                                errortext = errortext.replace(/\minloenegen/g, minloenegen);
                                $('#pNoteEgenIndtaegt').text(errortext);
                                $('#divNoteEgenIndtaegt').slideDown(slideValue);
                                return false;
                            } else if (loeninput > maxloenegen) {
                                errortext = $('#ErrorMaxLoenTextEgen').val();
                                errortext = errortext.replace(/\maxloenegen/g, maxloenegen);
                                $('#pErrorEgenIndtaegt').text(errortext);
                                $('#divErrorEgenIndtaegt').slideDown(slideValue);
                                return false;
                            }
                        // Hvis ægtefælles indtægt ikke er imellem minimum og maksimum
                        case 'uiTbIndtaegterAegtefaelle':
                            // Hvis Ægtefælle er valgt men indtægtsfeltet ikke er udfyldt
                            if (isNaN(loeninput) || loeninput == undefined || loeninput === '' || loeninput.length <= 0) {
                                errortext = $('#ErrorAegtefaelleIndtaegtManglendeText').val();
                                $('#pErrorAegtefaelleIndtaegt').text(errortext);
                                $('#divErrorAegtefaelleIndtaegt').slideDown(slideValue);
                                return false;
                            }// Hvis samlevers indtægt ikke er imellem minimum og maksimum
                            else if (loeninput < minloen) {
                                // $("#uiTbIndtaegterAegtefaelle").val(minloen);
                                errortext = $('#ErrorMinLoenText').val();
                                errortext = errortext.replace(/\minloen/g, minloen);
                                $('#pErrorAegtefaelleIndtaegt').text(errortext);
                                $('#divErrorAegtefaelleIndtaegt').slideDown(slideValue);
                                return false;
                            } else if (loeninput > maxloen) {
                                errortext = $('#ErrorMaxLoenText').val();
                                errortext = errortext.replace(/\maxloen/g, maxloen);
                                $('#pErrorAegtefaelleIndtaegt').text(errortext);
                                $('#divErrorAegtefaelleIndtaegt').slideDown(slideValue);
                                return false;
                            }
                        // Hvis samlevers indtægt ikke er udfyldt
                        case 'uiTbIndtaegterSamlever':
                            if (isNaN(loeninput) || loeninput == undefined || loeninput === '' || loeninput.length <= 0) {
                                errortext = $('#ErrorSamleverIndtaegtManglendeText').val();
                                $('#pErrorSamleverIndtaegt').text(errortext);
                                $('#divErrorSamleverIndtaegt').slideDown(slideValue);
                                return false;

                            }// Hvis samlevers indtægt ikke er imellem minimum og maksimum
                            else if (loeninput < minloen) {
                                errortext = $('#ErrorMinLoenText').val();
                                errortext = errortext.replace(/\minloen/g, minloen);
                                $('#pErrorSamleverIndtaegt').text(errortext);
                                $('#divErrorSamleverIndtaegt').slideDown(slideValue);
                                return false;
                            } else if (loeninput > maxloen) {
                                errortext = $('#ErrorMaxLoenText').val();
                                errortext = errortext.replace(/\maxloen/g, maxloen);
                                $('#pErrorSamleverIndtaegt').text(errortext);
                                $('#divErrorSamleverIndtaegt').slideDown(slideValue);
                                return false;
                            }
                        // Tester formue ikke overstiger maxværdi
                        case 'uiTbFormue':
                            return testFormue();
                        // Tester værdien af værdipapirer ikke overstiger maxværdi
                        case 'uiTbVaerdipapirer':
                            return testVaerdipapirer();
                        // Tester friværdi ikke overstiger maxværdi
                        case 'uiTbFrivaerdi':
                            return testFrivaerdi();
                        // Tester værdien af engangsindbetaling ikke overstiger maxværdi
                        case 'uiTbEkstraMaanedligIndbetaling':
                            return testMaanedligIndbetaling();
                        // Tester månedlig indbetaling ikke overstiger maxværdi
                        case 'uiTbEkstraEngangsIndbetaling':
                            return testEngangsIndbetaling();

                    }

                    return true;
                });



                // Når et inputfelt får fokus fjernes en evt. fejlbesked
                $('#uiTbIndtaegterAegtefaelle, #uiTbEgenIndtaegt, #uiTbIndtaegterSamlever, #uiTbFormue,  #uiTbFrivaerdi,  #uiTbVaerdipapirer, #uiTbEkstraMaanedligIndbetaling, #uiTbEkstraEngangsIndbetaling').on('focus', function () {
                    $(this).select();
                    var id = this.id;
                    switch (id) {
                        case 'uiTbEgenIndtaegt':
                            $('#divErrorEgenIndtaegt').slideUp(slideValue);
                            $('#divNoteEgenIndtaegt').slideUp(slideValue);
                            break;
                        case 'uiTbIndtaegterAegtefaelle':
                            $('#divErrorAegtefaelleIndtaegt').slideUp(slideValue);
                            $('#divNoteAegtefaelleIndtaegt').slideUp(slideValue);
                            break;
                        case 'uiTbIndtaegterSamlever':
                            $('#divErrorSamleverIndtaegt').slideUp(slideValue);
                            $('#divNoteSamleverIndtaegt').slideUp(slideValue);
                            break;
                        case 'uiTbFormue':
                            $('#divErrorFormue').slideUp(slideValue);
                            break;
                        case 'uiTbFrivaerdi':
                            $('#divErrorFrivaerdi').slideUp(slideValue);
                            break;
                        case 'uiTbVaerdipapirer':
                            $('#divErrorVaerdipapirer').slideUp(slideValue);
                            break;
                        case 'uiTbEkstraMaanedligIndbetaling':
                            $('#divErrorEkstraMaanedligIndbetaling').slideUp(slideValue);
                            break;
                        case 'uiTbEkstraEngangsIndbetaling':
                            $('#divErrorEkstraEngangsIndbetaling').slideUp(slideValue);
                            break;
                    }

                    return true;
                });
            }
        },
        tae: {
            init: function () {
                var slidevalue = 500;
                var modelvalue = 'dinErhvervsSituationModel.';

                var rdBtns = $('input:radio[name*="tae_"]');
                // init
                rdBtns.each(function () {
                    var tmp = this.name;
                    tmp = tmp.replace(modelvalue, '');
                    if ($(this).val() == 'ja' && $(this).prop('checked') == true) {
                        $('.' + tmp + '_toggle').slideDown(slidevalue);
                    }
                });
                // radiobutton change setup
                rdBtns.change(function () {
                    var tmp = this.name;
                    tmp = tmp.replace(modelvalue, '');
                    if ($(this).val() == 'nej') {
                        $('.' + tmp + '_nej_toggle').slideDown(slidevalue);
                    }
                    if ($(this).val() == 'ja') {
                        $('.' + tmp + '_toggle').slideDown(slidevalue);
                        $('.' + tmp + '_nej_toggle').slideUp(slidevalue);
                    } else {
                        $('.' + tmp + '_toggle').slideUp(slidevalue);
                    }
                });
                // $('#cbKreditorbeskyttelseAue').click(function () {

                //    if ($('#cbKreditorbeskyttelseAue').prop("checked") == true ) {
                //        $("#divKreditorbeskyttelse").slideDown(slidevalue);
                //    }
                //    else{
                //        $("#divKreditorbeskyttelse").slideUp(slidevalue);
                //    }

                //    $('#tbKontonummer').prop('disabled', $("#divKreditorbeskyttelse").height() > 1);
                //    $('#tbRegNr').prop('disabled', $("#divKreditorbeskyttelse").height() > 1);
                //    $('#cbNemkonto').prop('checked', false);

                //    if ($('#cbNemkonto').prop("checked") == false && !this.checked || $('#cbNemkonto').prop("checked") == undefined && !this.checked) {
                //        $('#tbKontonummer').prop('disabled', false);
                //        $('#tbRegNr').prop('disabled', false);
                //    }


                // });
                $('#cbNemkonto').click(function () {
                    $('#tbKontonummer').val('');
                    $('#tbRegNr').val('');
                    $('#tbKontonummer').prop('disabled', this.checked);
                    $('#tbRegNr').prop('disabled', this.checked);
                    // if ($("#divKreditorbeskyttelse").height() > 1)
                    //    $("#divKreditorbeskyttelse").slideUp();
                    $('#cbKreditorbeskyttelseKs').prop('checked', false);


                });

                $('#nextValidation').on('click', function () {
                    alertify.alert('Mobilnr. og e-mail adresse skal udfyldes');
                    return false;
                });

                $('#gemoplysninger').on('click', function () {
                    alertify.ok('Oplysningerne er gemt');
                    return false;
                });

            }
        },
        ks: {
            init: function () {
                $('[id^="cbDiagnose"]').click(function () {
                    $('#' + this.id.replace('cbDiagnose', 'subInfo')).slideToggle(500);
                });

                // init
                var slidevalue = 500;
                var modelvalue = 'DinSygdFormModel.';

                $('input:radio[name*="HarTidligereDiagnose"]').each(function () {
                    var tmp = this.name;
                    tmp = tmp.replace(modelvalue, '');
                    if ($(this).val() == 'ja' && $(this).prop('checked') == true) {
                        $('.' + tmp + '_toggle').slideDown(slidevalue);
                    }
                });
                // radiobutton change setup
                $('input:radio[name*="HarTidligereDiagnose"]').change(function () {
                    var tmp = this.name;
                    tmp = tmp.replace(modelvalue, '');
                    if ($(this).val() == 'nej') {
                        $('.' + tmp + '_nej_toggle').slideDown(slidevalue);
                    }
                    if ($(this).val() == 'ja') {
                        $('.' + tmp + '_toggle').slideDown(slidevalue);
                        $('.' + tmp + '_nej_toggle').slideUp(slidevalue);
                    } else {
                        $('.' + tmp + '_toggle').slideUp(slidevalue);
                    }
                });

                $('#cbKreditorbeskyttelseKs').click(function () {
                    // $("#divKreditorbeskyttelse").slideToggle(slidevalue);
                    // $('#tbKontonummer').prop('disabled', $("#divKreditorbeskyttelse").height()>1);
                    // $('#tbRegNr').prop('disabled', $("#divKreditorbeskyttelse").height()>1);
                    $('#cbNemkonto').prop('checked', false);
                    // $('#tbKontonummer').prop('disabled', true);
                    // $('#tbRegNr').prop('disabled', true);
                    $('#tbKontonummer').val('');
                    $('#tbRegNr').val('');
                    //  $("#divKreditorbeskyttelse").slideToggle(slidevalue);
                    $('#tbKontonummer').prop('disabled', this.checked);
                    $('#tbRegNr').prop('disabled', this.checked);

                    // if($('#cbNemkonto').prop("checked")==false && !this.checked || $('#cbNemkonto').prop("checked")==undefined && !this.checked)
                    // {
                    //    $('#tbKontonummer').prop('disabled', false);
                    //    $('#tbRegNr').prop('disabled', false);
                    // }


                });
            }
        },
        fleks: {
            init: function () {
                var slidevalue = 500;
                var modelvalue = 'OplysningerOmArbejdsgiverModel.';

                // init
                $('input:radio[name="OplysningerOmArbejdsgiverModel.IsFirstJob"]').each(function () {

                    var tmp = this.name;
                    tmp = tmp.replace(modelvalue, '');
                    if ($(this).val() == 'Ja' && $(this).prop('checked') == true) {
                        $('.' + tmp + '_toggle').slideDown(slidevalue);
                    }
                    if ($(this).val() == 'Nej' && $(this).prop('checked') == true) {
                        $('.' + tmp + '_toggle').slideDown(slidevalue);
                        $('.' + tmp + '_nej_toggle').slideDown(slidevalue);
                    }


                });
                // radiobutton change setup
                $('input:radio[name="OplysningerOmArbejdsgiverModel.IsFirstJob"]').change(function () {
                    var tmp = this.name;
                    tmp = tmp.replace(modelvalue, '');
                    if ($(this).val() == 'Nej') {
                        $('.' + tmp + '_nej_toggle').slideDown(slidevalue);
                        $('.' + tmp + '_toggle').slideDown(slidevalue);
                    }
                    if ($(this).val() == 'Ja') {
                        $('.' + tmp + '_toggle').slideDown(slidevalue);
                        $('.' + tmp + '_nej_toggle').slideUp(slidevalue);
                    }
                    // else {
                    //    $("." + tmp + "_toggle").slideUp(slidevalue);
                    // }
                });


                $('#nextValidation').on('click', function () {
                    alertify.alert('Mobilnr. og e-mail adresse skal udfyldes');
                    return false;
                });

                $('#gemoplysninger').on('click', function () {
                    alertify.ok('Oplysningerne er gemt');
                    return false;
                });

            }
        },
        tilpasforsikringer: {
            init: function () {

                function setKsTal() {
                    window.setTimeout(function () {
                        var selctedValue = $("input[name='vaelgKs']:checked").val();
                        switch (selctedValue) {
                            case 'ingendaekning':
                                $('#uiSpanKsIngendakningBeloeb').addClass('strong');
                                $('#uiSpanKs50Beloeb').removeClass('strong');
                                $('#uiSpanKs100Beloeb').removeClass('strong');
                                $('#uiSpanKs150Beloeb').removeClass('strong');
                                $('#samletPrisOmkostningerTekstDiv').html('<strong>Besparelse i kr./md.</strong>');
                                $('#samletPrisOmkostningerBeloebDiv').html('<strong>71 kr.</strong>');
                                $('#livslangAlderspensionEfter_tilpasforsikringer').html('<strong>10.023 kr.</strong>');
                                // $("#samletPrisOmkostningerDiv").html("<strong>111 kr.</strong>");
                                break;
                            case '50':
                                $('#uiSpanKsIngendakningBeloeb').removeClass('strong');
                                $('#uiSpanKs50Beloeb').addClass('strong');
                                $('#uiSpanKs100Beloeb').removeClass('strong');
                                $('#uiSpanKs150Beloeb').removeClass('strong');
                                $('#livslangAlderspensionEfter_tilpasforsikringer').html('<strong>9.912 kr.</strong>');
                                $('#samletPrisOmkostningerTekstDiv').html('<strong>Besparelse i kr./md.</strong>');
                                $('#samletPrisOmkostningerBeloebDiv').html('<strong>33 kr.</strong>');
                                // $("#samletPrisOmkostningerDiv").html("<strong>149 kr.</strong>");

                                break;
                            case '100':
                                $('#uiSpanKsIngendakningBeloeb').removeClass('strong');
                                $('#uiSpanKs50Beloeb').removeClass('strong');
                                $('#uiSpanKs100Beloeb').addClass('strong');
                                $('#uiSpanKs150Beloeb').removeClass('strong');
                                $('#livslangAlderspensionEfter_tilpasforsikringer').html('<strong>9.868 kr.</strong>');
                                $('#samletPrisOmkostningerTekstDiv').html('<strong>Besparelse i kr./md.</strong>');
                                $('#samletPrisOmkostningerBeloebDiv').html('<strong>0 kr.</strong>');
                                // $("#samletPrisOmkostningerDiv").html("<strong>182 kr.</strong>");
                                break;
                            case '150':
                                $('#uiSpanKsIngendakningBeloeb').removeClass('strong');
                                $('#uiSpanKs50Beloeb').removeClass('strong');
                                $('#uiSpanKs100Beloeb').removeClass('strong');
                                $('#uiSpanKs150Beloeb').addClass('strong');
                                $('#livslangAlderspensionEfter_tilpasforsikringer').html('<strong>9.753 kr.</strong>');
                                $('#samletPrisOmkostningerTekstDiv').html('<strong>Omkostninger i kr./md.</strong>');
                                $('#samletPrisOmkostningerBeloebDiv').html('<strong>6 kr.</strong>');
                                // $("#samletPrisOmkostningerDiv").html("<strong>188 kr.</strong>");
                                // $("#prognoseDiv").slideDown(slidevalue);
                                // $("#omkostningerDiv").slideDown(slidevalue);
                                break;
                        }
                    }, 1500);
                }



                function setTaeTal() {
                    window.setTimeout(function () {
                        var selctedValue = $("input[name='vaelgTae']:checked").val();
                        switch (selctedValue) {
                            case '100':
                                $('#uiSpanTae100Beloeb').addClass('strong');
                                $('#uiSpanTae150Beloeb').removeClass('strong');
                                $('#livslangAlderspensionEfter_tilpasforsikringer').html('<strong>9.868 kr.</strong>');
                                $('#samletPrisOmkostningerTekstDiv').html('<strong>Besparelse i kr./md.</strong>');
                                $('#samletPrisOmkostningerBeloebDiv').html('<strong>6 kr.</strong>');
                                // $("#samletPrisOmkostningerDiv").html("<strong>178 kr.</strong>");
                                break;
                            case '150':
                                $('#uiSpanTae100Beloeb').removeClass('strong');
                                $('#uiSpanTae150Beloeb').addClass('strong');
                                $('#livslangAlderspensionEfter_tilpasforsikringer').html('<strong>9.611 kr.</strong>');
                                $('#samletPrisOmkostningerTekstDiv').html('<strong>Besparelse i kr./md.</strong>');
                                $('#samletPrisOmkostningerBeloebDiv').html('<strong>0 kr.</strong>');
                                // $("#samletPrisOmkostningerDiv").html("<strong>182 kr.</strong>");
                                break;
                        }
                    }, 1500);
                }


                function setDoedTal() {
                    window.setTimeout(function () {
                        var selctedValue = $("input[name='vaelgDoed']:checked").val();
                        switch (selctedValue) {
                            case 'ingendaekning':
                                $('#uiSpanDoedIngendakningBeloeb').addClass('strong');
                                $('#uiSpanDoed300Beloeb').removeClass('strong');
                                $('#uiSpanDoed600Beloeb').removeClass('strong');
                                $('#samletPrisOmkostningerTekstDiv').html('<strong>Besparelse i kr./md.</strong>');
                                $('#samletPrisOmkostningerBeloebDiv').html('<strong>69 kr.</strong>');
                                $('#livslangAlderspensionEfter_tilpasforsikringer').html('<strong>10.210 kr.</strong>');
                                // $("#samletPrisOmkostningerDiv").html("<strong>113 kr.</strong>");
                                break;
                            case '300':
                                $('#uiSpanDoedIngendakningBeloeb').removeClass('strong');
                                $('#uiSpanDoed300Beloeb').addClass('strong');
                                $('#uiSpanDoed600Beloeb').removeClass('strong');
                                $('#livslangAlderspensionEfter_tilpasforsikringer').html('<strong>9.868 kr.</strong>');
                                $('#samletPrisOmkostningerTekstDiv').html('<strong>Besparelse i kr./md.</strong>');
                                $('#samletPrisOmkostningerBeloebDiv').html('<strong>0 kr.</strong>');
                                // $("#samletPrisOmkostningerDiv").html("<strong>182 kr.</strong>");
                                break;
                            case '600':
                                $('#uiSpanDoedIngendakningBeloeb').removeClass('strong');
                                $('#uiSpanDoed300Beloeb').removeClass('strong');
                                $('#uiSpanDoed600Beloeb').addClass('strong');
                                $('#livslangAlderspensionEfter_tilpasforsikringer').html('<strong>9.666 kr.</strong>');
                                $('#samletPrisOmkostningerTekstDiv').html('<strong>Omkostninger i kr./md.</strong>');
                                $('#samletPrisOmkostningerBeloebDiv').html('<strong>5 kr.</strong>');
                                // $("#samletPrisOmkostningerDiv").html("<strong>200 kr.</strong>");
                                break;
                        }
                    }, 1500);
                }




                var slidevalue = 1000;
                $("input[name='vaelgKs']").on('change', function () {
                    $('#prognoseDiv').slideUp(slidevalue).delay(slidevalue).slideDown(slidevalue);
                    $('#omkostningerDiv').slideUp(slidevalue).delay(slidevalue).slideDown(slidevalue);
                    setKsTal();
                });

                $("input[name='vaelgTae']").on('change', function () {
                    $('#prognoseDiv').slideUp(slidevalue).delay(slidevalue).slideDown(slidevalue);
                    $('#omkostningerDiv').slideUp(slidevalue).delay(slidevalue).slideDown(slidevalue);
                    setTaeTal();
                });

                $("input[name='vaelgDoed']").on('change', function () {
                    $('#prognoseDiv').slideUp(slidevalue).delay(slidevalue).slideDown(slidevalue);
                    $('#omkostningerDiv').slideUp(slidevalue).delay(slidevalue).slideDown(slidevalue);
                    setDoedTal();
                });


            }
        },
        begunstigelser: {
            init: function () {

                $(document).ready(function () {
                    // Tilknytter onchange events til de modtager elementer der er på siden fra start af.
                    tilknytEvents('EnModtager', 1);
                    // tilknytEvents("AltModtager", 1);
                    // tilknytEvents("FlereModtagere", 0);
                    // tilknytEvents("FlereModtagere", 1);

                    var iterationIntegerEksisterendeAlt = parseInt($('.EkstraAlternativBegunstigelse').length + 1);
                    for (var i = 1; i < iterationIntegerEksisterendeAlt; i++) {
                        tilknytEvents('AltModtager', i);
                    }

                    var iterationIntegerEksisterendeFlere = parseInt($('.EkstraPrimaerBegunstigelse').length);
                    for (var i = 0; i < iterationIntegerEksisterendeFlere; i++) {
                        tilknytEvents('FlereModtagere', i);
                    }

                    $(document).on('keyup', function (event) {
                        if (event.which == 13) {
                            if ($('#uiBtnTilfoejAlternativBegunstigelse').is(':focus')) { $('#uiBtnTilfoejAlternativBegunstigelse').click(); }

                            if ($('#uiBtnTilfoejPrimaerBegunstigelse').is(':focus')) { $('#uiBtnTilfoejPrimaerBegunstigelse').click(); }
                        }
                    });

                    // $('<div/>', {
                    //    'class': 'EkstraAlternativBegunstigelse', html: GetHtml()
                    // }).appendTo('#containerBegunstigelserAlternativ'); //Get the html from template
                    // Når medlemmet tilføjer nye dynamiske modtager elementer ved at trykke på knappen
                    $('#uiBtnTilfoejAlternativBegunstigelse').click(function () {
                        // Optæller hvor mange modtager elementer vi er oppe på.
                        var iterationInteger = parseInt($('.EkstraAlternativBegunstigelse').length + 1);
                        // Giver et id til container så vi senere kan referere den (ifm tooltip).
                        var elmID = 'ekstraAltBegunstContainer' + iterationInteger;
                        $('<div/>', {
                            'id': elmID,
                            'class': 'EkstraAlternativBegunstigelse', html: GetHtmlAlternativ() // Laver dynamisk html
                        }).hide().appendTo('#containerBegunstigelserAlternativ').slideDown('slow');// Glider til syne
                        // Tilknytter lightbox event
                        App.Util.lightbox.init('#' + elmID);
                        // Tilknytter onchange events på input felterne
                        tilknytEvents('AltModtager', iterationInteger);

                    });



                    // Når medlemmet tilføjer nye dynamiske modtager elementer ved at trykke på knappen
                    $('#uiBtnTilfoejPrimaerBegunstigelse').click(function () {
                        // Optæller hvor mange modtager elementer vi er oppe på.
                        var iterationInteger = parseInt($('.EkstraPrimaerBegunstigelse').length);
                        // Giver et id til container så vi senere kan referere den (ifm tooltip).
                        var elmIDPrimaer = 'ekstraPrimaerBegunstContainer' + iterationInteger;
                        $('<div/>', {
                            'id': elmIDPrimaer,
                            'class': 'EkstraPrimaerBegunstigelse', html: GetHtmlPrimaer()// Laver dynamisk html
                        }).hide().appendTo('#containerBegunstigelserPrimaer').slideDown('slow');// Glider til syne
                        // Tilknytter lightbox event
                        App.Util.lightbox.init('#' + elmIDPrimaer);

                        tilknytEvents('FlereModtagere', iterationInteger);
                    });
                    // Tilknytter validering af samtlige felter når brugeren trykker Næste
                    $('#uiBtnNaesteVaelgSelvEnModt').click(function () {
                        return ValiderEnModtager();
                    });

                    $('#uiBtnNaesteVaelgSelvFlereModt').click(function () {
                        return ValiderFlereModtagere();
                    });

                });

                // function CprnrErGentaget(elemNavn, elementCprId) {
                //     var returnvalue = false;
                //     var duplikater = 0;

                //     //Hack fordi at enmodtager og alternative modtageres cpr inputfelt har Name = AltModtager. Det skal de have for at kunne sammenlignes.
                //     if (elemNavn === "EnModtager")
                //         elemNavn = "AltModtager";

                //     var cprnrVaerdiArray = $('[name=cpr' + elemNavn + ']');
                //     for (i = 0; i < cprnrVaerdiArray.length; i++)
                //     {
                //         if ($.trim($(cprnrVaerdiArray[i]).val()) === $.trim($(elementCprId).val()))
                //         {
                //             duplikater = duplikater + 1;
                //             if (duplikater == 2)
                //                 returnvalue = true;
                //         }
                //     }
                //     return returnvalue;
                // }

                // Tester at der ikke er gentaget cprnumre i de forskellige felter
                function CprErGentagetTesterAlleElemter(elemNavn, elementCprId) {


                    var returnvalue = false;
                    var duplikater = 0;
                    // $("[name*='Cpr'" + elemNavn + "]").each(function () {
                    $("[name*='SelectedCpr" + elemNavn + "']").each(function () {
                        // Fjern mellemrum og evt. bindestreg fra denne boks cpr
                        // Fjern mellemrum og evt. bindestreg fra de andre bokses som sammenlignes' cpr
                        if ($.trim(this.value).replace(/\-/g, '') === $.trim($(elementCprId).val()).replace(/\-/g, '')) {
                            duplikater = duplikater + 1;
                            if (duplikater == 2) { returnvalue = true; }
                        }
                    });
                    return returnvalue;
                }

                function HarIndtastetEgetCpr(elementCprId) {
                    // CPR input
                    var cpr = $.trim($(elementCprId).val()).replace(/\-/g, '');
                    var egetCprnr = $('#egetCprnr').val();

                    if (egetCprnr === cpr) {
                        // Tester om medlemmet har udfyldt eget cprnr
                        return true;
                        // setValidationError(elementCprId);
                        // $(elementCprId).next('div').children('p').text($("#errorEgetCprnr").val());

                    }
                    return false;
                }

                // tester at der er indtastet både fornavn og efternavn
                function HarIndtastetFornavnOgEfternavn(elementNavnId) {
                    var returVaerdi = true;
                    var navn = $.trim($(elementNavnId).val());
                    if (navn.indexOf(' ') === -1) { returVaerdi = false; }

                    return returVaerdi;
                }

                // Denne funktion valdierer andelene
                function andelValider(ElementAndelId) {


                    var number = $.trim($(ElementAndelId).val()).replace(',', '.');

                    if (isNaN(number)) {
                        setValidationError(ElementAndelId);
                        $(ElementAndelId).parent('div').next('div').children('p').text($('#errorAndelUgyldigt').val());
                        return false;
                    }

                    // Hvis tallet indeholder mere end 2 decimaler smider vi de overskydende i skraldespanden (uden at runde op)
                    if (number.toString().indexOf('.') != -1) {
                        $(ElementAndelId).val(number.toString().substring(0, number.toString().indexOf('.') + 3).replace('.', ','));
                        number = number.toString().substring(0, number.toString().indexOf('.') + 3);
                    }

                    // Test om den indtastede fordelingspct er mindre end 1
                    if (number < 1) {
                        setValidationError(ElementAndelId);
                        $(ElementAndelId).parent('div').next('div').children('p').text($('#errorAndelIkkeUnder1').val());
                        return false;
                    }

                    // Test om den indtastede fordelingspct er større end 99
                    if (number > 99) {
                        setValidationError(ElementAndelId);
                        $(ElementAndelId).parent('div').next('div').children('p').text($('#errorAndelIkkeOver99').val());
                        return false;
                    }
                    return true;
                }

                function sumerFordeling() {
                    // Deklarer variabel til sum
                    var fordelingIalt = 0;
                    var stringArray;
                    var returnvalue = true;

                    var andelVaerdiArray = $("[name*='SelectedAndelFlereModtagere']");
                    for (var i = 0; i < andelVaerdiArray.length; i++) {

                        // Lægger værdien i number variablen og ændrer et evt. komma til punktum, så parseFloat virker og så begge indtastninger er gyldige.
                        var number = $.trim($(andelVaerdiArray[i]).val()).replace(',', '.');
                        // Test om andel er udfyldt
                        if (number != '') {

                            if (isNaN(number)) {
                                setValidationError(andelVaerdiArray[i]);
                                $(andelVaerdiArray[i]).parent('div').next('div').children('p').text($('#errorAndelUgyldigt').val());
                                returnvalue = false;
                            }

                            // Hvis tallet indeholder mere end 2 decimaler smider vi de overskydende i skraldespanden (uden at runde op)
                            if (number.toString().indexOf('.') != -1) {
                                $(andelVaerdiArray[i]).val(number.toString().substring(0, number.toString().indexOf('.') + 3).replace('.', ','));
                                number = number.toString().substring(0, number.toString().indexOf('.') + 3);
                            }

                            // Test om den indtastede fordelingspct er mindre end 1
                            if (number < 1) {
                                setValidationError(andelVaerdiArray[i]);
                                $(andelVaerdiArray[i]).parent('div').next('div').children('p').text($('#errorAndelIkkeUnder1').val());
                                returnvalue = false;
                            }

                            // Test om den indtastede fordelingspct er større end 99
                            if (number > 99) {
                                setValidationError(andelVaerdiArray[i]);
                                $(andelVaerdiArray[i]).parent('div').next('div').children('p').text($('#errorAndelIkkeOver99').val());
                                returnvalue = false;
                            }

                            // debugger;
                            if (i == 0) { stringArray = number + '|'; } else { stringArray = stringArray + number + '|'; }

                            // Det er et valid tal. Sumér det
                            fordelingIalt = parseFloat(fordelingIalt) + parseFloat(number);
                        }
                    }

                    if (fordelingIalt >= 99 && fordelingIalt <= 100 && $('#divLigeligFordelingAdvarsel').is(':visible')) {
                        // return true;
                        $('#divFejlMindst99').slideUp(500);
                        $('#divFejlIkkeOver100').slideUp(500);
                    }

                    // Tjek om der skal vises advarsel omkring ligelig fordeling
                    if (!$('#divLigeligFordelingAdvarsel').is(':visible') && udskrivBeskedOmLigeligFordeling(fordelingIalt, stringArray)) {
                        $('#divLigeligFordelingAdvarsel').slideDown(500);

                        returnvalue = false;
                    } else {
                        $('#divLigeligFordelingAdvarsel').slideUp(500);
                    }
                    if (fordelingIalt > 100) {
                        $('#divFejlMindst99').slideUp(500);
                        $('#divFejlIkkeOver100').slideDown(500);
                        // var andelVaerdiArray = $('[name=andelFlereModtagere]');
                        for (var i = 0; i < andelVaerdiArray.length; i++) {
                            if ($.trim($(andelVaerdiArray[i]).val()) != '') {
                                setValidationError(andelVaerdiArray[i]);
                                $(andelVaerdiArray[i]).parent('div').next('div').children('p').text($('#errorAndeleTilsammenOver100').val());
                            }
                        }
                        returnvalue = false;
                    } else if (fordelingIalt > 0 && fordelingIalt < 99) {
                        $('#divFejlMindst99').slideDown(500);
                        $('#divFejlIkkeOver100').slideUp(500);
                        // var andelVaerdiArray = $('[name=andelFlereModtagere]');
                        for (var i = 0; i < andelVaerdiArray.length; i++) {
                            if ($.trim($(andelVaerdiArray[i]).val()) != '') {
                                setValidationError(andelVaerdiArray[i]);
                                $(andelVaerdiArray[i]).parent('div').next('div').children('p').text($('#errorAndeleTilsammenUnder99').val());
                            }
                        }
                        returnvalue = false;
                    } else {
                        $('#divFejlMindst99').slideUp(500);
                        $('#divFejlIkkeOver100').slideUp(500);
                    }

                    return returnvalue;
                }

                // Undersøg om alle forholdstallene er ens
                function ForholdstalleneErAlleEns(strArray) {
                    if (strArray.length == 1 || strArray.length == 0) {
                        return true;
                    }
                    for (var i = 0; i < strArray.length; i++) {
                        if (i > 0 && strArray[i] != strArray[i - 1]) {
                            return false;
                        }
                    }
                    return true;
                }

                // Her forsøges at give brugeren en meddelelse, hvis vi tror medlemmet er interesseret i at fordele pengene ligeligt imellem de begunstigede, men alligevel har angivet en lille forskel i procentfordelingen
                // F.eks. 33.3%, 33.3% og 33.4% eller 33%, 33% og 34% m.m.
                // Hvis forholdstallene ikke er ens
                function udskrivBeskedOmLigeligFordeling(fordelingIalt, stringArray) {
                    var visAdvarsel = true;
                    // Summen skal være 100% for at det er relevant at vise beskeden omkring ligelig fordeling. Det er jo kun i tilfælde hvor brugeren har angivet en skæv fordeling med en sum på 100% at dette er relevant.
                    // Alle forholdstallene kan ikke være ens
                    if (fordelingIalt == 100 && !ForholdstalleneErAlleEns(stringArray)) {

                        stringArray = stringArray.substring(0, stringArray.lastIndexOf('|'));

                        var arrayNumbersString = stringArray.split('|');
                        if (arrayNumbersString.length <= 2) // Der skal være minimum 3 begunstigede
                        { return false; }

                        for (var i = 0; i < arrayNumbersString.length; i++) {
                            for (var k = 0; k < arrayNumbersString.length; k++) {
                                if (parseFloat(arrayNumbersString[i]) <= (parseFloat(arrayNumbersString[k]) + 1) &&
                                    parseFloat(arrayNumbersString[i]) >= (parseFloat(arrayNumbersString[k]) - 1)) continue;

                                visAdvarsel = false;
                                break;
                            }
                        }
                        return visAdvarsel;
                    }
                    return false;
                }


                // Tilknytter onchange events på input felterne
                function tilknytEvents(elemNavn, idnr) {
                    // Relation dropdown
                    var elementRelationId = '#uiDdlRelation' + elemNavn + idnr;
                    $(elementRelationId).on('change', function () {
                        // feltet er obligatorisk
                        if (!validateRequiredField(elementRelationId)) {
                            $(elementRelationId).next('div').children('p').text($('#errorRelationSkalUdfyldes').val());
                        }
                    });

                    var elementCprId = '#uiTbCpr' + elemNavn + idnr;
                    $(elementCprId).on('change', function () {

                        // CPR input
                        // var cpr = $.trim($(elementCprId).val()).replace(/\-/g, "");
                        // var egetCprnr = $("#egetCprnr").val();

                        // Hvis info feltet omkring modulus 11 er aktivt så gemmes det først ved onchange.
                        $(elementCprId).parent().parent().prev('div.msg.hide').slideUp(500);
                        // feltet er obligatorisk
                        if (!validateRequiredField(elementCprId)) {
                            $(elementCprId).next('div').children('p').text($('#errorCprSkalUdfyldes').val());
                        } else if (HarIndtastetEgetCpr(elementCprId)) {
                            // Tester om medlemmet har udfyldt eget cprnr
                            setValidationError(elementCprId);
                            $(elementCprId).next('div').children('p').text($('#errorEgetCprnr').val());
                        } else if (CprErGentagetTesterAlleElemter(elemNavn, elementCprId)) {
                            // Tester om medlemmet har udfyldt samme cprnr i flere cpr felter
                            setValidationError(elementCprId);
                            $(elementCprId).next('div').children('p').text($('#errorCprGentaget').val());
                        } else if (!validateCpr(elementCprId)) {
                            // Tester om cpr opfylder valideringsregler
                            $(elementCprId).next('div').children('p').text($('#errorCprUgyldigt').val());
                        } else {
                            // Tester om cprnr opfylder Modulus 11 check
                            var chk = 0;
                            var cpr = $.trim($(elementCprId).val()).replace(/\-/g, '');
                            for (var i = 9; i > -1; i--) {
                                chk += (+cpr.charAt(i)) * ((i > 2) ? (10 - i) : (4 - i));
                            }
                            // cprnr opfylder Modulus 11 check
                            if (chk % 11 === 0) {
                                $(elementCprId).parent().parent().prev('div.msg.hide').slideUp(500);
                            } // cprnr opfylder ikke Modulus 11 check
                            else if (chk % 11 !== 0) {
                                $(elementCprId).parent().parent().prev('div.msg.hide').slideDown(500);
                            }
                        }
                    });

                    var elementNavnId = '#uiTbNavn' + elemNavn + idnr;
                    $(elementNavnId).on('change', function () {
                        // feltet er obligatorisk
                        if (!validateRequiredField(elementNavnId)) {
                            $(elementNavnId).next('div').children('p').text($('#errorNavnSkalUdfyldes').val());
                        } else if (!validateName(elementNavnId)) {
                            $(elementNavnId).next('div').children('p').text($('#errorNavnUgyldigt').val());
                        } else if (!HarIndtastetFornavnOgEfternavn(elementNavnId)) {
                            setValidationError(elementNavnId);
                            $(elementNavnId).next('div').children('p').text($('#errorNavnIkkeKomplet').val());
                        }
                    });

                    var elementAndelId = '#uiTbAndel' + elemNavn + idnr;
                    $(elementAndelId).on('change', function () {
                        // feltet er obligatorisk
                        if (!validateRequiredField(elementAndelId)) {
                            $(elementAndelId).parent('div').next('div').children('p').text($('#errorAndelSkalUdfyldes').val());
                        } else if (andelValider(elementAndelId)) {
                            setValidationOk(elementAndelId);
                        }
                    });
                }

                // Denne funktion validerer felterne brugeren har indtastet under fanebladet "Flere modtagere"
                function ValiderFlereModtagere() {
                    var inputErValide = true;

                    // Gennemløber de to obligatoriske primære modtagere og validerer inputfelterne.
                    for (var i = 0; i <= 1; i++) {

                        /// /Hent de indtastede værdier for to primær modtagere
                        // var relationEnModtagerValue = $('#uiDdlRelationFlereModtagere' + i + ' option:selected').val();
                        // var cprEnModtagerValue = $("#uiTbCprFlereModtagere" + i).val();
                        // var navnEnModtagerValue = $("#uiTbNavnFlereModtagere" + i).val();

                        // Det er obligatorisk at indtaste mindst to modtager ved valg af "flere modtagere".

                        // Relation er obligatorisk
                        if (!validateRequiredField($('#uiDdlRelationFlereModtagere' + i))) { inputErValide = false; }

                        // Cpr er obligatorisk
                        if (!validateRequiredField($('#uiTbCprFlereModtagere' + i))) {
                            $('#uiTbCprFlereModtagere' + i).next('div').children('p').text($('#errorCprSkalUdfyldes').val());
                            inputErValide = false;
                        }// Valider Cpr
                        else if (!validateCpr($('#uiTbCprFlereModtagere' + i))) {
                            $('#uiTbCprFlereModtagere' + i).next('div').children('p').text($('#errorCprUgyldigt').val());
                            inputErValide = false;
                        } else if (CprErGentagetTesterAlleElemter('FlereModtagere', $('#uiTbCprFlereModtagere' + i))) {
                            setValidationError($('#uiTbCprFlereModtagere' + i));
                            $($('#uiTbCprFlereModtagere' + i)).next('div').children('p').text($('#errorCprGentaget').val());
                            inputErValide = false;
                        } else if (HarIndtastetEgetCpr($('#uiTbCprFlereModtagere' + i))) {
                            // Tester om medlemmet har udfyldt eget cprnr
                            setValidationError($('#uiTbCprFlereModtagere' + i));
                            $($('#uiTbCprFlereModtagere' + i)).next('div').children('p').text($('#errorEgetCprnr').val());
                            inputErValide = false;
                        }

                        // Navn er obligatorisk
                        if (!validateRequiredField($('#uiTbNavnFlereModtagere' + i))) {
                            $('#uiTbNavnFlereModtagere' + i).next('div').children('p').text($('#errorNavnSkalUdfyldes').val());
                            inputErValide = false;
                        }
                        // Valider Navn
                        else if (!validateName($('#uiTbNavnFlereModtagere' + i))) {
                            $('#uiTbNavnFlereModtagere' + i).next('div').children('p').text($('#errorNavnUgyldigt').val());
                            inputErValide = false;
                        } else if (!HarIndtastetFornavnOgEfternavn($('#uiTbNavnFlereModtagere' + i))) {
                            setValidationError($('#uiTbNavnFlereModtagere' + i));
                            $('#uiTbNavnFlereModtagere' + i).next('div').children('p').text($('#errorNavnIkkeKomplet').val());
                            inputErValide = false;
                        }


                        // Andel er obligatorisk
                        if (!validateRequiredField($('#uiTbAndelFlereModtagere' + i))) {
                            $('#uiTbAndelFlereModtagere' + i).parent('div').next('div').children('p').text($('#errorAndelSkalUdfyldes').val());
                            inputErValide = false;
                        }
                        // Valider andel
                        else if (!andelValider($('#uiTbAndelFlereModtagere' + i))) {
                            // $("#uiTbAndelFlereModtagere" + i).next('div').children('p').text($("#errorAndelUgyldigt").val());
                            inputErValide = false;
                        } else // Hvis alt er ok sættes evt. fejl tilbage
                        {
                            setValidationOk($('#uiTbAndelFlereModtagere' + i));
                        }
                    }

                    // Finder antallet af tilføjede primære modtagere
                    var iterationInteger = parseInt($('.EkstraPrimaerBegunstigelse').length);

                    // Gennemløber de dynamisk tilføjede primære modtagere og validerer inputfelterne.
                    for (var i = 2; i <= iterationInteger; i++) {

                        // Hent de indtastede værdier for første alternative modtager
                        var relationFlereModtagereValue = $('#uiDdlRelationFlereModtagere' + i + ' option:selected').val();
                        var cprFlereModtagereValue = $('#uiTbCprFlereModtagere' + i).val();
                        var navnFlereModtagereValue = $('#uiTbNavnFlereModtagere' + i).val();
                        var andelFlereModtagereValue = $('#uiTbAndelFlereModtagere' + i).val();
                        // Hvis brugeren har indtastet noget i inputfelterne omkring alternative modtagere skal de valideres


                        // if (($.trim(relationFlereModtagereValue).length === 0 || $.trim(cprFlereModtagereValue).length === 0 || $.trim(navnFlereModtagereValue).length === 0 || $.trim(andelFlereModtagereValue).length === 0) &&
                        if ($.trim(relationFlereModtagereValue).length > 0 || $.trim(cprFlereModtagereValue).length > 0 || $.trim(navnFlereModtagereValue).length > 0 || $.trim(andelFlereModtagereValue).length > 0) {
                            // if (!($.trim(relationFlereModtagereValue).length === 0 || $.trim(cprFlereModtagereValue).length === 0 || $.trim(navnFlereModtagereValue).length === 0 || $.trim(andelFlereModtagereValue).length === 0)){
                            // Relation er obligatorisk
                            if (!validateRequiredField($('#uiDdlRelationFlereModtagere' + i))) {
                                inputErValide = false;
                            }

                            // Cpr er obligatorisk
                            if (!validateRequiredField($('#uiTbCprFlereModtagere' + i))) {
                                $('#uiTbCprFlereModtagere' + i).next('div').children('p').text($('#errorCprSkalUdfyldes').val());
                                inputErValide = false;
                            }
                            // Valider Cpr
                            else if (!validateCpr($('#uiTbCprFlereModtagere' + i))) {
                                $('#uiTbCprFlereModtagere' + i).next('div').children('p').text($('#errorCprUgyldigt').val());
                                inputErValide = false;
                            } else if (CprErGentagetTesterAlleElemter('FlereModtagere', $('#uiTbCprFlereModtagere' + i))) {
                                setValidationError($('#uiTbCprFlereModtagere' + i));
                                $($('#uiTbCprFlereModtagere' + i)).next('div').children('p').text($('#errorCprGentaget').val());
                                inputErValide = false;
                            } else if (HarIndtastetEgetCpr($('#uiTbCprFlereModtagere' + i))) {
                                // Tester om medlemmet har udfyldt eget cprnr
                                setValidationError($('#uiTbCprFlereModtagere' + i));
                                $($('#uiTbCprFlereModtagere' + i)).next('div').children('p').text($('#errorEgetCprnr').val());
                                inputErValide = false;
                            }


                            // Navn er obligatorisk
                            if (!validateRequiredField($('#uiTbNavnFlereModtagere' + i))) {
                                $('#uiTbNavnFlereModtagere' + i).next('div').children('p').text($('#errorNavnSkalUdfyldes').val());
                                inputErValide = false;
                            }
                            // Valider Navn
                            else if (!validateName($('#uiTbNavnFlereModtagere' + i))) {
                                $('#uiTbNavnFlereModtagere' + i).next('div').children('p').text($('#errorNavnUgyldigt').val());
                                inputErValide = false;
                            } else if (!HarIndtastetFornavnOgEfternavn($('#uiTbNavnFlereModtagere' + i))) {
                                setValidationError($('#uiTbNavnFlereModtagere' + i));
                                $('#uiTbNavnFlereModtagere' + i).next('div').children('p').text($('#errorNavnIkkeKomplet').val());
                                inputErValide = false;
                            }

                            // Andel er obligatorisk
                            if (!validateRequiredField($('#uiTbAndelFlereModtagere' + i))) {
                                $('#uiTbAndelFlereModtagere' + i).parent('div').next('div').children('p').text($('#errorAndelSkalUdfyldes').val());
                                inputErValide = false;
                            }
                            // Valider andel
                            else if (!andelValider($('#uiTbAndelFlereModtagere' + i))) {
                                // $("#uiTbAndelFlereModtagere" + i).parent('div').next('div').children('p').text($("#errorAndelUgyldigt").val());
                                inputErValide = false;
                            } else // Hvis alt er ok sættes evt. fejl tilbage
                            {
                                setValidationOk($('#uiTbAndelFlereModtagere' + i));
                            }


                        } else {
                            setValidationOk($('#uiDdlRelationFlereModtagere' + i));
                            setValidationOk($('#uiTbCprFlereModtagere' + i));
                            setValidationOk($('#uiTbNavnFlereModtagere' + i));
                            setValidationOk($('#uiTbAndelFlereModtagere' + i));
                        }
                    }

                    // Sumer andel og valider summen
                    if (!sumerFordeling()) {
                        inputErValide = false;
                    }

                    // Hvis ikke validering er korrekt kan brugerne ikke gå til næste side
                    return inputErValide;
                }

                // Denne funktion validerer felterne brugeren har indtastet under fanebladet "Én modtager"
                function ValiderEnModtager() {
                    var inputErValide = true;

                    // Hent de indtastede værdier for En primær modtager
                    var relationEnModtagerValue = $('#uiDdlRelationEnModtager1 option:selected').val();
                    var cprEnModtagerValue = $('#uiTbCprEnModtager1').val();
                    var navnEnModtagerValue = $('#uiTbNavnEnModtager1').val();




                    // Det er obligatorisk at indtaste mindst én modtager ved valg af "èn modtager".
                    // Relation er obligatorisk
                    if (!validateRequiredField($('#uiDdlRelationEnModtager1'))) { inputErValide = false; }


                    // Cpr er obligatorisk
                    if (!validateRequiredField($('#uiTbCprEnModtager1'))) {
                        $('#uiTbCprEnModtager1').next('div').children('p').text($('#errorCprSkalUdfyldes').val());
                        inputErValide = false;
                    }// Valider Cpr
                    else if (!validateCpr($('#uiTbCprEnModtager1'))) {
                        $('#uiTbCprEnModtager1').next('div').children('p').text($('#errorCprUgyldigt').val());
                        inputErValide = false;
                    } else if (CprErGentagetTesterAlleElemter('AltModtager', $('#uiTbCprEnModtager1'))) {
                        setValidationError($('#uiTbCprEnModtager1'));
                        $($('#uiTbCprEnModtager1')).next('div').children('p').text($('#errorCprGentaget').val());
                        inputErValide = false;
                    } else if (HarIndtastetEgetCpr($('#uiTbCprEnModtager1'))) {
                        // Tester om medlemmet har udfyldt eget cprnr
                        setValidationError($('#uiTbCprEnModtager1'));
                        $('#uiTbCprEnModtager1').next('div').children('p').text($('#errorEgetCprnr').val());
                        inputErValide = false;
                    }


                    // Navn er obligatorisk
                    if (!validateRequiredField($('#uiTbNavnEnModtager1'))) {
                        $('#uiTbNavnEnModtager1').next('div').children('p').text($('#errorNavnSkalUdfyldes').val());
                        inputErValide = false;
                    }
                    // Valider Navn
                    else if (!validateName($('#uiTbNavnEnModtager1'))) {
                        $('#uiTbNavnEnModtager1').next('div').children('p').text($('#errorNavnUgyldigt').val());
                        inputErValide = false;
                    } else if (!HarIndtastetFornavnOgEfternavn($('#uiTbNavnEnModtager1'))) {
                        setValidationError($('#uiTbNavnEnModtager1'));
                        $('#uiTbNavnEnModtager1').next('div').children('p').text($('#errorNavnIkkeKomplet').val());
                        inputErValide = false;
                    }
                    // Kun hvis accordian Tilføj alternativ modtager er foldet, skal der valideres på input felterne omkring de alternative modtagere
                    if ($('#uiSectionAltModtagere').is(':visible')) {

                        // Finder antallet af alternative modtagere
                        var iterationInteger = parseInt($('.EkstraAlternativBegunstigelse').length + 1);
                        // Gennemløber de alternative modtagere og validerer inputfelterne.
                        for (var i = 1; i <= iterationInteger; i++) {

                            // Hent de indtastede værdier for første alternative modtager
                            var relationAltModtagerValue = $('#uiDdlRelationAltModtager' + i + ' option:selected').val();
                            var cprAltModtagerValue = $('#uiTbCprAltModtager' + i).val();
                            var navnAltModtagerValue = $('#uiTbNavnAltModtager' + i).val();
                            // Hvis brugeren har indtastet noget i inputfelterne omkring alternative modtagere skal de valideres
                            // if (($.trim(relationAltModtagerValue).length === 0 || $.trim(cprAltModtagerValue).length === 0 || $.trim(navnAltModtagerValue).length === 0) &&
                            if ($.trim(relationAltModtagerValue).length > 0 || $.trim(cprAltModtagerValue).length > 0 || $.trim(navnAltModtagerValue).length > 0) {
                                // if (!($.trim(relationAltModtagerValue).length === 0 || $.trim(cprAltModtagerValue).length === 0 || $.trim(navnAltModtagerValue).length === 0)){
                                // Relation er obligatorisk
                                if (!validateRequiredField($('#uiDdlRelationAltModtager' + i))) {
                                    $('#uiDdlRelationAltModtager' + i).parent('div').next('div').children('p').text($('#errorRelationSkalUdfyldes').val());
                                    inputErValide = false;
                                }

                                // Cpr er obligatorisk
                                if (!validateRequiredField($('#uiTbCprAltModtager' + i))) {
                                    $('#uiTbCprAltModtager' + i).next('div').children('p').text($('#errorCprSkalUdfyldes').val());
                                    inputErValide = false;
                                }
                                // Valider Cpr
                                else if (!validateCpr($('#uiTbCprAltModtager' + i))) {
                                    $('#uiTbCprAltModtager').next('div').children('p').text($('#errorCprUgyldigt').val());
                                    inputErValide = false;
                                } else if (CprErGentagetTesterAlleElemter('AltModtager', $('#uiTbCprAltModtager' + i))) {
                                    setValidationError($('#uiTbCprAltModtager' + i));
                                    $($('#uiTbCprAltModtager' + i)).next('div').children('p').text($('#errorCprGentaget').val());
                                    inputErValide = false;
                                } else if (HarIndtastetEgetCpr($('#uiTbCprAltModtager' + i))) {
                                    // Tester om medlemmet har udfyldt eget cprnr
                                    setValidationError($('#uiTbCprAltModtager' + i));
                                    $('#uiTbCprAltModtager' + i).next('div').children('p').text($('#errorEgetCprnr').val());
                                    inputErValide = false;
                                }

                                // Navn er obligatorisk
                                if (!validateRequiredField($('#uiTbNavnAltModtager' + i))) {
                                    $('#uiTbNavnAltModtager' + i).next('div').children('p').text($('#errorNavnSkalUdfyldes').val());
                                    inputErValide = false;
                                }
                                // Valider Navn
                                else if (!validateName($('#uiTbNavnAltModtager' + i))) {
                                    $('#uiTbNavnAltModtager' + i).next('div').children('p').text($('#errorNavnUgyldigt').val());
                                    inputErValide = false;
                                } else if (!HarIndtastetFornavnOgEfternavn($('#uiTbNavnAltModtager' + i))) {
                                    setValidationError($('#uiTbNavnAltModtager' + i));
                                    $('#uiTbNavnAltModtager' + i).next('div').children('p').text($('#errorNavnIkkeKomplet').val());
                                    inputErValide = false;
                                }

                            } else {
                                setValidationOk($('#uiDdlRelationAltModtager' + i));
                                setValidationOk($('#uiTbCprAltModtager' + i));
                                setValidationOk($('#uiTbNavnAltModtager' + i));
                            }
                        }

                    }

                    // Hvis ikke validering er korrekt kan brugerne ikke gå til næste side
                    return inputErValide;
                }


                // Danner HTML ud fra skabelonen og giver felterne ID'er og names
                function GetHtmlAlternativ() // Get the template and update the input field names
                {
                    var len = $('.EkstraAlternativBegunstigelse').length + 1;
                    var $html = $('#AlternativBegunstigelseTemplate').clone();

                    var altModtager = $html.find('[name=spanAltModtager]');
                    altModtager[0].id = 'uiSpanAltModtager' + len;
                    altModtager[0].innerHTML = len;

                    // var relationAlternativ = $html.find('[name=relationAltModtager]');
                    var relationAlternativ = $html.find("[name='HddFormModel.ModtList[x].SelectedRelationAltModtager']");
                    relationAlternativ[0].id = 'uiDdlRelationAltModtager' + len;
                    relationAlternativ[0].name = 'HddFormModel.ModtList[' + len + '].SelectedRelationAltModtager';
                    relationAlternativ[0].selctedValue = '';

                    var cprAlternativ = $html.find("[name='HddFormModel.ModtList[x].SelectedCprAltModtager']");
                    cprAlternativ[0].id = 'uiTbCprAltModtager' + len;
                    cprAlternativ[0].name = 'HddFormModel.ModtList[' + len + '].SelectedCprAltModtager';
                    cprAlternativ[0].value = '';

                    var navnAlternativ = $html.find("[name='HddFormModel.ModtList[x].SelectedNavnAltModtager']");
                    navnAlternativ[0].id = 'uiTbNavnAltModtager' + len;
                    navnAlternativ[0].name = 'HddFormModel.ModtList[' + len + '].SelectedNavnAltModtager';
                    navnAlternativ[0].value = '';

                    var andelAfBeloebAlternativ = $html.find("[name='altAndelAfBeloeb']");
                    andelAfBeloebAlternativ[0].name = 'uiLblAltAndelAfBeloeb';
                    andelAfBeloebAlternativ[0].id = 'uiLblAltAndelAfBeloeb' + len;
                    var andel = 100 / len;
                    andelAfBeloebAlternativ[0].innerHTML = Math.floor(andel) + '%';
                    andelAfBeloebAlternativ.addClass('spanklasse');

                    var $andelAfBeloebElementer = $('.spanklasse');
                    for (var j = 0; j < $andelAfBeloebElementer.length; j++) {
                        $andelAfBeloebElementer[j].innerHTML = Math.floor(andel) + '%';
                    }

                    return $html.html();
                }

                // Danner HTML ud fra skabelonen og giver felterne ID'er og names
                function GetHtmlPrimaer() {
                    var len = $('.EkstraPrimaerBegunstigelse').length;
                    var $html = $('#PrimaerBegunstigelseTemplate').clone();
                    var modtagerPrimaer = $html.find('[name=spanFlereModtagerPrimaer]');
                    modtagerPrimaer[0].id = 'uiSpanFlereModtagerPrimaer' + len;
                    modtagerPrimaer[0].innerHTML = (len + 1);

                    var relationFlereModtagere = $html.find("[name='HddFormModel.ModtFlereList[x].SelectedRelationFlereModtagere']");
                    relationFlereModtagere[0].id = 'uiDdlRelationFlereModtagere' + len;
                    relationFlereModtagere[0].name = 'HddFormModel.ModtFlereList[' + len + '].SelectedRelationFlereModtagere';
                    relationFlereModtagere[0].value = '';

                    var cprFlereModtagere = $html.find("[name='HddFormModel.ModtFlereList[x].SelectedCprFlereModtagere']");
                    cprFlereModtagere[0].id = 'uiTbCprFlereModtagere' + len;
                    cprFlereModtagere[0].name = 'HddFormModel.ModtFlereList[' + len + '].SelectedCprFlereModtagere';

                    var navnFlereModtagere = $html.find("[name='HddFormModel.ModtFlereList[x].SelectedNavnFlereModtagere']");
                    navnFlereModtagere[0].id = 'uiTbNavnFlereModtagere' + len;
                    navnFlereModtagere[0].name = 'HddFormModel.ModtFlereList[' + len + '].SelectedNavnFlereModtagere';
                    navnFlereModtagere[0].value = '';

                    var parAndel = $html.find('[name=spanAndel]');
                    parAndel[0].innerHTML = (len + 1);

                    var andelAfBeloebFlereModtagere = $html.find("[name='HddFormModel.ModtFlereList[x].SelectedAndelFlereModtagere']");
                    andelAfBeloebFlereModtagere[0].id = 'uiTbAndelFlereModtagere' + len;
                    andelAfBeloebFlereModtagere[0].name = 'HddFormModel.ModtFlereList[' + len + '].SelectedAndelFlereModtagere';
                    andelAfBeloebFlereModtagere[0].value = '';

                    return $html.html();
                }


                //* ********Godkend*************
                // Fejlvisning hvis ikke der godkendes betingelser
                // function validerGodkendBetingelser() {

                //     var confirm = $("#begunstigelserConfirm");

                //     if (!confirm.is(":checked")) {
                //         $("#divErrorAcceptBetingelser").addClass("error");
                //         return false;
                //     }

                //     return true;
                // }
                // $("#uiBtnGodkendBegunstigelse").on("click", function () {
                //     return validerGodkendBetingelser();
                // });

                // $("#begunstigelserConfirm").change(function (e) {
                //     if ($(this).is(":checked")) {
                //         $("#divErrorAcceptBetingelser").removeClass("error");
                //     }
                // });



                //* ******Modtager siden*****
                // Fjerner evt. fejlbesked om at der skal vælges, så snart der tages et radioknap valg.
                $('#uiRdbtnVaelgNaermestePaaroerende').on('click', function () {
                    $('#divErrorVaelgModtager').slideUp(500);
                });
                // Fjerner evt. fejlbesked om at der skal vælges, så snart der tages et radioknap valg.
                $('#uiRdbtnVaelgSelvModtager').on('click', function () {
                    $('#divErrorVaelgModtager').slideUp(500);
                });


            },
            seomockup:
            {
                init: function () {

                }
            }
        },

        fileUploadMockup:
        {
            init: function () {
                // $('#btnUploadUdenforLogin').click(function () {
                //    if ($('td[name=VedhaeftFiler]').not(':checked'))
                //        return false;
                //    var RecaptchaChecked = grecaptcha.getResponse().length != 0;
                //    var VedhaeftetFilerChedked = $('input[name="VedhaeftFiler"]').is(":checked");
                //    var ErDerUploadetFiler = $('.fileupload-table tbody tr').length > 0;
                //    var ReadyToProceed = false;

                //    if (!VedhaeftetFilerChedked) //er der ikke vedhæftet filer skal Recaptcha ikke være chedked
                //        ReadyToProceed = true;

                //    if (VedhaeftetFilerChedked && !ErDerUploadetFiler) //er vedhæftet filer checked men der ikke er uploadet filer kan man godt gå videre
                //        ReadyToProceed = true;

                //    if (VedhaeftetFilerChedked && ErDerUploadetFiler && RecaptchaChecked) //er der vedhæftet filer, upload filer chedked og recaptcha checked
                //        ReadyToProceed = true;

                //    if (ReadyToProceed)
                //        alertify.confirmation("Dine data er nu sendt til Industriens Pension...");
                //    else
                //        App.Util.fileUpload.ShowRecaptchaError();
                //    //ellers skal der vises valideringsfejl
                // }
                // )

                $('input[name="VedhaeftFiler"]').prop('checked', true);

                $('button[class="btn btn-silent delete"]').click(function () { alert('TEST'); });
                $('button[class="btn btn-silent delete"]').click(function () {
                    alert('DELETE FROM LIST');
                });

                $('input[name="VedhaeftFiler"]').click(function () {
                    if ($(this).is(':checked')) {
                        $('.sendkode').slideDown(500);
                    } else {
                        App.Util.fileUploadMockup.hide();
                        $('.sendkode').slideUp(500);
                    }

                });
                // $("#tbemail").blur(function () {
                //    if ($("#rbtnsendkodeemail").is(":checked"))
                //        $('#tbemailsms').val($(this).val());
                // });

                // $("#tbtelefonnummer").blur(function () {
                //    if ($("#rbtnsendkodesms").is(":checked"))
                //        $('#tbemailsms').val($(this).val());
                // });

                // $('#btnsendkode').click(function () {
                //    App.Util.fileUploadMockup.hide();
                //    $('.indtastkode').slideToggle(500);
                // });

                // $('#btnindtastkode').click(function () {
                //    App.Util.fileUploadMockup.hide();
                //    $('.fileuploader').slideDown(500);
                // });

                // $('#rbtnsendkodesms').click(function () {
                //    $('#tbemailsms').val($('#tbtelefonnummer').val());
                // });
                // $('#rbtnsendkodeemail').click(function () {
                //    $('#tbemailsms').val($('#tbemail').val());
                // });

                //    $('#btnUploadUdenforLogin').click(function () {
                //        var RecaptchaChecked = grecaptcha.getResponse().length != 0;
                //        var VedhaeftetFilerChedked = $('input[name="VedhaeftFiler"]').is(":checked");
                //        var ErDerUploadetFiler = $('.fileupload-table tbody tr').length > 0;

                //        if (!RecaptchaChecked && VedhaeftetFilerChedked && ErDerUploadetFiler)
                //            App.Util.fileUpload.ShowRecaptchaError();
                //    });
                //    $("#btnNaesteUpload").click(
                //        function() {
                //            var str = getUploadedFileNames(); //from fileupload.js
                //            $("#hiddenFilelist").val(str);
                //        }
                // );

            },
            hide: function () {
                if ($('.sendkode').is(':visible')) { $('.sendkode').slideUp(500); }
                if ($('.indtastkode').is(':visible')) { $('.indtastkode').slideUp(500); }
                if ($('.fileuploader').is(':visible')) { $('.fileuploader').slideUp(500); }
            },
            ShowRecaptchaError:
                function () {
                    $('.divrecaptcha').addClass('recaptcha-error');
                    $('.recaptcha-error-message').show();
                },
            RemoverecaptcaError:
                function () {
                    $('.divrecaptcha').removeClass('recaptcha-error');
                    $('.recaptcha-error-message').hide();
                }
        },
        stopforindbetalinger:
        {
            init: function () {
                var disableBtn = false;
                var disableGodkendBtn = false;

                var minindbetaling = parseFloat($('#minindbetaling').val());
                var maxindbetaling = parseFloat($('#maxindbetaling').val());
                var slideValue = 500;

                var ajaxFormSubmit = function () {
                    disableBtn = true;
                    $('#btnSelvbetalerShowPrognose').addClass('is-loading');

                    var $form = $(this);
                    var options = {
                        url: $form.attr('action'),
                        type: $form.attr('method'),
                        data: $form.serialize(),
                        error: function () {
                            disableBtn = false;
                            $('#btnSelvbetalerShowPrognose').removeClass('is-loading');
                            $('#divErrorSkalBeregne').slideDown(slideValue);

                        }
                    };

                    $.ajax(options).done(function (data) {
                        disableBtn = false;
                        $('#btnSelvbetalerShowPrognose').removeClass('is-loading');
                        var $target = $($form.attr('data-selfpay-target'));
                        var $newHtml = $(data);

                        $target.html(function () {
                            return $($newHtml).hide().fadeIn(2000, 'linear');

                        });
                        App.Util.lightbox.init();
                        App.pensionForecastGraph.init('.box-prognose-new');
                        popGraphInlineFunction('68');
                    });

                    return false;

                };

                $("form[data-selfpay-ajax='true']").submit(ajaxFormSubmit);

                // Når der klikkes på beregn
                $('#btnSelvbetalerShowPrognose').on('click', function () {
                    if (disableBtn) {
                        event.preventDefault();
                        return false;
                    }
                    if (!validateEgenindbetaling()) {
                        event.preventDefault();
                        return false;
                    }
                    $('#beregnForm').submit();
                    $('#divErrorSkalBeregne').slideUp(slideValue);
                    return true;
                });

                $('#btnNaesteSelvbetalerStart').on('click', function () {
                    if (disableBtn) {
                        event.preventDefault();
                        return false;
                    }
                    if (!validateEgenindbetaling()) {
                        event.preventDefault();
                        return false;
                    } else {
                        // klik på næste hent values fra ajax form til sitecore form
                        $('#egenIndbetaling').val($('#uiTbEgenIndbetaling').val().replace(/\./g, '').replace(',', '.'));
                        // $("#alder").val($("#uiDdlSelvbetalerPensAlder").val());
                    }
                    return true;
                });

                // kun et klik på godkend
                $('#uiBtnGodkend').click(function (event) {
                    if (disableGodkendBtn) {
                        event.preventDefault();
                        return false;
                    }
                    return true;
                });

                // Godkend side link erstatter knap visuelt
                $('#uiLnkGodkend').on('click', function () {
                    var confirm = $('#chkbxConfirm');
                    if (!confirm.is(':checked')) {
                        $('#divErrorAcceptBetingelser').addClass('error');
                        return false;
                    } else {
                        $(this).addClass('is-loading');
                        event.preventDefault();
                        $('#uiBtnGodkend').click();
                        disableGodkendBtn = true;
                    }
                    return true;
                });


                function validatePensionsAlder() {
                    if (!validateRequiredField('#alder')) {
                        $('#alder').slideDown(slideValue);
                        return false;
                    }
                    return true;
                }

                function validateEgenindbetaling() {
                    var errortext;
                    var indbetalinginput = parseFloat($('#uiTbEgenIndbetaling').val().replace(/\./g, '').replace(',', '.'));
                    if (isNaN(indbetalinginput) ||
                        indbetalinginput == undefined ||
                        indbetalinginput === '' ||
                        indbetalinginput.length <= 0) {
                        errortext = $('#ErrorEgenIndbetalingManglendeText').val();
                        $('#pErrorEgenIndbetaling').text(errortext);
                        $('#divErrorEgenIndbetaling').slideDown(slideValue);
                        return false;
                    }// Egen indtægt skal være imellem minimum og maksimum
                    else if (indbetalinginput < minindbetaling) {
                        errortext = $('#ErrorMinIndbetalingTextEgen').val();
                        errortext = errortext.replace(/\minindbetaling/g, minindbetaling);
                        $('#pErrorEgenIndbetaling').text(errortext);
                        $('#divErrorEgenIndbetaling').slideDown(slideValue);
                        return false;
                    } else if (indbetalinginput > maxindbetaling) {
                        errortext = $('#ErrorMaxIndbetalingTextEgen').val();
                        errortext = errortext.replace(/\maxindbetaling/g, maxindbetaling);
                        $('#pErrorEgenIndbetaling').text(errortext);
                        $('#divErrorEgenIndbetaling').slideDown(slideValue);
                        return false;
                    }
                    return true;
                }

                // Når inputfelt får fokus fjernes en evt. fejlbesked
                $('#uiTbEgenIndbetaling').on('focus', function () {
                    $(this).select();
                    var id = this.id;
                    switch (id) {
                        case 'uiTbEgenIndbetaling':
                            $('#divErrorEgenIndbetaling').slideUp(slideValue);
                            break;
                        // case "uiDdlSelvbetalerPensAlder":
                        //    $("#divErrorPensionsAlder").slideUp(slideValue);
                        //    break;
                    }
                    if ($('#partialPrognose').children().length > 0) {
                        $('#partialPrognose').fadeOut(1500, 'linear');
                    }
                    $('#divErrorBeregnInvalidModelState').slideUp(slideValue);
                    $('#divErrorSkalBeregne').slideUp(slideValue);
                    return true;
                });

                // Når inputfelt mister fokus
                $('#uiTbEgenIndbetaling').on('blur', function () {
                    var indbetalinginput = parseFloat($(this).val().replace(/\./g, '').replace(',', '.'));
                    var errortext;
                    var id = this.id;
                    switch (id) {
                        // Hvis egen indbetaling ikke er imellem minimum og maksimum
                        case 'uiTbEgenIndbetaling':
                            if (isNaN(indbetalinginput) || indbetalinginput == undefined ||
                                indbetalinginput === '' ||
                                indbetalinginput.length <= 0) {
                                errortext = $('#ErrorEgenIndbetalingManglendeText').val();
                                $('#pErrorEgenIndbetaling').text(errortext);
                                $('#divErrorEgenIndbetaling').slideDown(slideValue);
                                return false;
                            } else if (indbetalinginput < minindbetaling) {
                                errortext = $('#ErrorMinIndbetalingTextEgen').val();
                                errortext = errortext.replace(/\minindbetaling/g, minindbetaling);
                                $('#pErrorEgenIndbetaling').text(errortext);
                                $('#divErrorEgenIndbetaling').slideDown(slideValue);
                                return false;
                            } else if (indbetalinginput > maxindbetaling) {
                                errortext = $('#ErrorMaxIndbetalingTextEgen').val();
                                errortext = errortext.replace(/\maxindbetaling/g, maxindbetaling);
                                $('#pErrorEgenIndbetaling').text(errortext);
                                $('#divErrorEgenIndbetaling').slideDown(slideValue);
                                return false;
                            } else {
                                // style the number in before showing it in the input field
                                if (indbetalinginput >= 1000) {
                                    indbetalinginput = indbetalinginput / 1000;
                                    $(this).val(indbetalinginput.toFixed(3));
                                } else {
                                    $(this).val(indbetalinginput.toFixed());
                                }

                            }
                            break;
                        // case "uiDdlSelvbetalerPensAlder":
                        //    if (validatePensionsAlder()) {
                        //        $("#divErrorPensionsAlder").slideUp(slideValue);
                        //    }
                        //    break;
                    }
                    return true;
                });



                $('#chkbxConfirm').change(function (e) {
                    if ($(this).is(':checked')) {
                        $('#divErrorAcceptBetingelser').removeClass('error');
                    }
                });
            }
        },

        pensionsberegner:
        {
            // prognose feltet skal skjules da der ikke er en prognose at vise
            init: function () {
                $('.collectionbox').hide();
                $('.loadingdiv').hide();
                // initialisering af sliders
                App.Util.pensionsberegner.setupAlderRangeSlider('#rsCurrentAge');
                App.Util.pensionsberegner.setupAlderRangeSlider('#rsPensionYear');
                App.Util.pensionsberegner.setupRangeSlider('#rsEkstra', 0, 28100, 200, 0);

                $('input[name^=rbtnpensionsberegner]').on('click', function () {
                    resetWarning(); // Defineret på cshtml -
                    App.Util.pensionsberegner.setupRanges();
                    if (App.Util.pensionsberegner.isReadyToCalculate()) { App.Util.pensionsberegner.calculate(); }
                });

            },

            calculate: function () {

                var pensionsType = $('input[name=rbtnpensionsberegner1]:checked').attr('id');
                var indbetalingsMaade = $('input[name=rbtnpensionsberegner2]:checked').attr('id');
                var indbetaling = $('#ipEkstra').val();
                var alder = $('#ipCurrentAge').val();
                var pensionsAlder = $('#ipPensionYear').val();
                // Function must be on cshtml view - because of ajax call
                doPrognose(alder, pensionsAlder, pensionsType, indbetalingsMaade, indbetaling);
                // annimation
                var speed = 1000;
                $('.collectionbox').slideUp(speed, function () {
                    $('.loadingdiv').slideDown(speed);
                });
            },

            calculateDone: function () {
                // When result ready:
                var speed = 1000;
                $('.loadingdiv').slideUp(speed, function () {
                    $('.collectionbox').slideDown(speed);
                });
            },

            isReadyToCalculate: function () {
                // er alt udfyldt rigtigt?
                var udbetalingAfPension = $('input[name=rbtnpensionsberegner1]').is(':checked');
                // var ekstraPension = $('input[name=rbtnpensionsberegner2]').is(":checked"); // sat som default
                var indbetaling = $('#ipEkstra').val() != 0;
                return (udbetalingAfPension && indbetaling);
            },


            setupRangeSlider: function (selector, min, max, step, value) {
                $(selector)
                    .rangeslider('destroy')
                    .attr({ min: min, max: max, step: step }).val(value)
                    .rangeslider({
                        polyfill: false,
                        onSlideEnd: function (selector) {
                            // skjul evt. fejlbesked - finder sliderens input's parent(div)
                            var inpVal = this.$element.parents('.info-box').find('.sliderOut').parent();
                            inpVal.removeClass('error');
                            inpVal.next('.msg.error').hide();

                            resetWarning(); // Defineret på cshtml -


                            var currentAmount = $('#rsEkstra').val();
                            var maxAmount = this.$element.parents('.info-box').find('#rsEkstra').attr('max');

                            if (currentAmount == max) {
                                showOverloebWarning();
                            } else {
                                resetWarning();
                            }

                            if (App.Util.pensionsberegner.isReadyToCalculate() == true) {
                                App.Util.pensionsberegner.calculate();
                            }
                        }
                    })
                    .change();

            },

            // Csh tilføjelse
            setupAlderRangeSlider: function (selector) {
                $(selector)
                    .rangeslider('destroy')
                    .rangeslider({
                        polyfill: false,
                        onSlideEnd: function (selector) {

                            var element = this.$element[0].id; // rsCurrentAge, rsPensionYear
                            var currentAge = $('#rsCurrentAge').val();
                            var pensionYear = $('#rsPensionYear').val();

                            currentAge++;

                            if (currentAge > pensionYear) {
                                // CurrentAge flyttes
                                if (element == 'rsCurrentAge') {
                                    $('#ipPensionYear').val(currentAge);
                                    var api1 = $('#rsPensionYear').data('plugin_rangeslider');
                                    if (api1 != null) {
                                        api1.setPosition(api1.getPositionFromValue(currentAge));
                                    }
                                } else if (element == 'rsPensionYear') {
                                    // PensionYear flyttes
                                    $('#ipCurrentAge').val(pensionYear - 1);
                                    var api2 = $('#rsCurrentAge').data('plugin_rangeslider');
                                    if (api2 != null) {
                                        var x = api2.getPositionFromValue(pensionYear - 1);
                                        api2.setPosition(x);
                                    }
                                }
                            }
                            // skjul evt. fejlbesked - finder sliderens input's parent(div)
                            var inpVal = this.$element.parents('.info-box').find('.sliderOut').parent();
                            inpVal.removeClass('error');
                            inpVal.next('.msg.error').hide();

                            if (App.Util.pensionsberegner.isReadyToCalculate() == true) {
                                App.Util.pensionsberegner.calculate();
                            }

                        }
                    })
                    .change();

            },


            loadSliderValues: function (spanSelector) {
                var values = $(spanSelector).html().split(',');
                var min = parseInt(values[0]);
                var max = parseInt(values[1]);
                var step = parseInt(values[2]);

                App.Util.pensionsberegner.setupRangeSlider('#rsEkstra', min, max, step, 0);
            },

            setupRanges: function () {
                var udbetalingAfPension = $('input[name=rbtnpensionsberegner1]').is(':checked');
                var ekstraPension = $('input[name=rbtnpensionsberegner2]').is(':checked');

                // er udbetaling ikke valgt bruges første valg (aldersopsparing) som default
                if (udbetalingAfPension == false && ekstraPension == true) {
                    App.Util.pensionsberegner.loadSliderValues('#uiSp_AlderFast');
                }
                if (udbetalingAfPension && ekstraPension) {
                    var udbetalingAfPensionSelected = $('input[name=rbtnpensionsberegner1]:checked').attr('id');
                    var ekstraPensionSelected = $('input[name=rbtnpensionsberegner2]:checked').attr('id');

                    if (udbetalingAfPensionSelected == 'ekstraaldersforsikring' && ekstraPensionSelected == 'fastmaanedligtbeloeb') {
                        App.Util.pensionsberegner.loadSliderValues('#uiSp_AlderFast');
                    } else if (udbetalingAfPensionSelected == 'ekstraaldersforsikring' && ekstraPensionSelected == 'engangsbeloeb') {
                        App.Util.pensionsberegner.loadSliderValues('#uiSp_AlderEngangs');
                    } else if (udbetalingAfPensionSelected == 'ekstrapension' && ekstraPensionSelected == 'fastmaanedligtbeloeb') {
                        App.Util.pensionsberegner.loadSliderValues('#uiSp_EPFast');
                    } else if (udbetalingAfPensionSelected == 'ekstrapension' && ekstraPensionSelected == 'engangsbeloeb') {
                        App.Util.pensionsberegner.loadSliderValues('#uiSp_EPEngangs');
                    } else if (udbetalingAfPensionSelected == 'livslangekstrapension' && ekstraPensionSelected == 'fastmaanedligtbeloeb') {
                        App.Util.pensionsberegner.loadSliderValues('#uiSp_LivslangFast');
                    } else if (udbetalingAfPensionSelected == 'livslangekstrapension' && ekstraPensionSelected == 'engangsbeloeb') {
                        App.Util.pensionsberegner.loadSliderValues('#uiSp_LivslangEngangs');
                    }
                }
            }

        },
        fileUploader: {
            init: function() {
                if (document.querySelector('.js-file-upload')) import('./func/fileupload/index').then(module => module.default.init());
            }
        }
    };

    App.Slider = {
        init: function () {
            var $scrollable = $('.scrollable');
            if ($scrollable.length > 0) {
                $scrollable.each(function () {
                    $el = $(this);

                    var $panels = $el.find('.panels');
                    $panels.find('.panel:first').addClass('firstPanel');
                    var hasPaging = $el.hasClass('has-paging');
                    $panel = $el.find('.panel');

                    if ($panel.length == 1) {
                        $el.removeClass('has-prevnext');
                        return false;
                    }

                    var conf = {
                        speed: 500,
                        autoplay: false,
                        paging: hasPaging,
                        interval: 5000,
                        loop: true,
                        width: null,
                        height: null,
                        keyboard: true,
                        indexed: false
                    };

                    var meta = $el.metadata();
                    conf = $.extend(conf, meta);

                    var api;

                    if ($el.hasClass('scrollable-vertical')) {
                        $el = $el.find('.panels-container');

                        api = $el.scrollable({ items: '.panels', vertical: true, speed: conf.speed });

                        if (conf.paging) {
                            api.navigator({ navi: '.scrollable-vertical .nav', activeClass: 'current', indexed: conf.indexed });
                        }
                    } else {
                        if (!conf.width) {
                            conf.width = $el.width();
                        }
                        if (!conf.height) {
                            conf.height = $panels.height();
                        }

                        $el.height(conf.height).width(conf.width);

                        $panelPadding = $panel.width() - $panel.innerWidth();

                        var rootClass = document.documentElement.className;
                        var isMsie = rootClass.match(/msie/);
                        if (isMsie) {
                            $panelPadding = $panelPadding + 1; // IE8 Fix: 1px float panel roundup bug
                        }
                        $panel.width(conf.width + $panelPadding + 1);

                        api = $el.scrollable({
                            items: '.panels', circular: conf.loop, speed: conf.speed, easing: conf.easing, keyboard: conf.keyboard, onSeek: function () {
                                var i = this.getIndex();
                                $panel.removeClass('current');
                                $panel.eq(i).toggleClass('current');
                            }
                        });

                        if (conf.paging) {
                            // page counter fix for ie7
                            if (isMsie && rootClass.match(/lt-ie8/)) {
                                $el.find('.panel ').not('.cloned').each(function () {
                                    $el.find('.panel-count').append("<a href='#'>&nbsp;</a>");
                                });
                                $el.find('.panel-count a:first').addClass('current');
                            }
                            api.navigator({ navi: '.panel-count', naviItem: 'a', activeClass: 'current', indexed: conf.indexed });
                        }

                    }

                    if (conf.autoplay) {
                        api.autoscroll({ autoplay: true, interval: conf.interval, api: true });
                    }
                });
            }
        }
    };

    App.Upload =
    {
        Init: function () {
            function GetUploadetFiles() {
                alert('hi');
            }
        }
    };

    App.pensionForsikringGraf = new function () {
        var self = this;

        this.init = function () {
            var ths = $(this);
            var values = $("input[type='radio'].radioGraph").map(function () { return parseInt($(this).val(), 0); }).get();
            this.Mx = Math.max.apply(Math, values);
            this.Mn = Math.min.apply(Math, values);

            $("input[type='radio'].radioGraph").click(function () {
                $(this).closest('table').find('tr').removeClass('sel');

                var o = $(this).closest('tr');
                o.addClass('sel');
                o.next('tr.details').addClass('sel');

                var name = $(this).attr('name');
                var selectedVal = parseInt($(this).val(), 0);
                var nuvaerendeVal = parseInt($("input[name='" + name + "'].radioGraph.nuvaerende").val(), 0);
                var dxVal = selectedVal - nuvaerendeVal;

                var key = '';
                if (name == 'vaelgKs') {
                    key = '.cart-Ks';
                } else if (name == 'vaelgTae') {
                    key = '.cart-Tae';
                } else if (name == 'vaelgDoed') {
                    key = '.cart-Dod';
                }
                var v1 = IntToCurrencyDkk(selectedVal);
                var v2 = (dxVal > 0 ? '+ ' : '') + IntToCurrencyDkk(dxVal);
                if (key) {
                    $('.cart-value' + key).html(v1);
                    $('.cart-diff' + key).html(v2);
                }

                self.calcAndSet(parseInt($(this).val(), 0));
            });

            var v = $("input[type='radio'].radioGraph:checked").val();
            self.calcAndSet(parseInt(v, 0));

        };
        var pattern = /(-?\d+)(\d{3})/;
        function IntToCurrencyDkk(val) {
            var x = '' + val;
            while (pattern.test(x)) { x = x.replace(pattern, '$1.$2'); }

            return x + ' kr.';
        }

        this.initialValue = 50;
        this.Mx = 1;
        this.Mn = 0;

        this.calcAndSet = function (val) {
            // var val = parseInt($(this).val(), 0);
            var scale = self.Mx - self.Mn;
            var dx = (val - self.Mn) * 100.0 / scale;
            var impact = Math.round(self.initialValue - (dx / 3.0));

            self.setValue(impact);
        };

        this.setValue = function (val) {

            var valCorr = val / 0.7 + 15;

            var valC = (valCorr * 300) / 100;
            var valC4 = valC + 4;
            var graphTextAnchor = 'middle';
            if (val > 75) graphTextAnchor = 'end';
            if (val < 25) graphTextAnchor = 'start';
            document.getElementById('graphLeftSide').setAttribute('width', valC4);
            document.getElementById('graphMarkerGroup').setAttribute('x', valC4);
            document.getElementById('graphText').setAttribute('text-anchor', graphTextAnchor);
            document.getElementById('graphText').textContent = '' + (100 - val) + ' kr./md.';
            // document.getElementById('pensionMdrDif').innerText = "" + (100 - val) + " kr.";
        };
    };

    App.pensionForecastGraph = pensionForecastGraph;

    $.fn.center = function () {
        this.css('position', 'absolute');
        this.css('top', Math.max(0, (($(window).height() - $(this).outerHeight()) / 2) +
            $(window).scrollTop()) + 'px');
        this.css('left', Math.max(0, (($(window).width() - $(this).outerWidth()) / 2) +
            $(window).scrollLeft()) + 'px');
        return this;
    };

    $.fn.filterByData = function (prop, val) {
        return this.filter(
            function () { return $(this).data(prop) == val; }
        );
    };

    // Run it!
    $(document).ready(App.common.init);
    $(window).on('load', App.Slider.init);
    $(document).ready(App.Util.equalHeight.calculate);
    $(window).resize(App.Util.equalHeight.calculate);
})(jQuery);

function loadScripts() {
    if(document.querySelector('.js-kontaktbanner')) {
        import('@mockup/func/contact-banner/index').then((module) => new module.default());
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadScripts);
} else {
    loadScripts();
}
